// Course Data - English for Brazilians in Japan
// Complete course structure with lessons, quizzes, and phrases

export const userProgress = {
  currentStreak: 0,
  totalXP: 0,
  level: 1,
  lessonsCompleted: 0,
  totalLessons: 100,
  dailyGoal: 10, // minutes
  dailyProgress: 0, // minutes completed today
  badges: [
    { id: 'first-lesson', name: 'Primeira Lição', icon: '🎯', earned: false },
    { id: 'week-streak', name: '7 Dias Seguidos', icon: '🔥', earned: false },
    { id: 'perfect-quiz', name: 'Quiz Perfeito', icon: '⭐', earned: false },
    { id: 'daily-master', name: 'Meta Diária x10', icon: '🏆', earned: false },
    { id: 'polyglot', name: 'Poliglota', icon: '🌍', earned: false },
  ],
  reviewQueue: 0, // phrases due for review
};

export const tracks = [
  {
    id: 'daily-life',
    title: 'Daily Life',
    titlePt: 'Vida Diária',
    description: 'Inglês para situações cotidianas no Japão',
    icon: '🏠',
    color: 'primary',
    totalLessons: 25,
    completedLessons: 0,
    locked: false,
  },
  {
    id: 'work-factory',
    title: 'Work & Factory',
    titlePt: 'Trabalho e Fábrica',
    description: 'Comunicação no ambiente de trabalho',
    icon: '🏭',
    color: 'accent',
    totalLessons: 25,
    completedLessons: 0,
    locked: false,
  },
  {
    id: 'truck-logistics',
    title: 'Truck & Logistics',
    titlePt: 'Caminhão e Logística',
    description: 'Vocabulário para motoristas e logística',
    icon: '🚛',
    color: 'warning',
    totalLessons: 25,
    completedLessons: 0,
    locked: false,
  },
  {
    id: 'business',
    title: 'Business',
    titlePt: 'Negócios',
    description: 'Inglês profissional e reuniões',
    icon: '💼',
    color: 'success',
    totalLessons: 25,
    completedLessons: 0,
    locked: false,
  },
];

export const lessons = {
  'daily-life': [
    // Módulo 1: Primeiros Passos
    { id: 'dl-1', title: 'Greetings & Introductions', titlePt: 'Cumprimentos e Apresentações', duration: 5, xp: 50, completed: false, current: true, type: 'vocabulary' },
    { id: 'dl-2', title: 'Basic Questions', titlePt: 'Perguntas Básicas', duration: 5, xp: 50, completed: false, type: 'conversation' },
    { id: 'dl-3', title: 'Numbers & Time', titlePt: 'Números e Horas', duration: 6, xp: 60, completed: false, type: 'vocabulary' },
    { id: 'dl-4', title: 'Days & Months', titlePt: 'Dias e Meses', duration: 5, xp: 50, completed: false, type: 'vocabulary' },
    { id: 'dl-5', title: 'Polite Expressions', titlePt: 'Expressões de Cortesia', duration: 6, xp: 60, completed: false, type: 'conversation' },
    
    // Módulo 2: Lojas e Compras
    { id: 'dl-6', title: 'At the Convenience Store', titlePt: 'Na Loja de Conveniência', duration: 7, xp: 75, completed: false, type: 'conversation' },
    { id: 'dl-7', title: 'Shopping for Groceries', titlePt: 'Comprando no Supermercado', duration: 6, xp: 65, completed: false, type: 'vocabulary' },
    { id: 'dl-8', title: 'Asking for Prices', titlePt: 'Perguntando Preços', duration: 5, xp: 55, completed: false, type: 'conversation' },
    { id: 'dl-9', title: 'Payment Methods', titlePt: 'Formas de Pagamento', duration: 6, xp: 60, completed: false, type: 'vocabulary' },
    { id: 'dl-10', title: 'Returning Items', titlePt: 'Devolvendo Produtos', duration: 7, xp: 70, completed: false, type: 'conversation' },
    
    // Módulo 3: Transporte
    { id: 'dl-11', title: 'Taking the Train', titlePt: 'Pegando o Trem', duration: 6, xp: 60, completed: false, type: 'listening' },
    { id: 'dl-12', title: 'Bus Transportation', titlePt: 'Transporte de Ônibus', duration: 6, xp: 60, completed: false, type: 'vocabulary' },
    { id: 'dl-13', title: 'Buying Tickets', titlePt: 'Comprando Passagens', duration: 7, xp: 70, completed: false, type: 'conversation' },
    { id: 'dl-14', title: 'Asking for Directions', titlePt: 'Pedindo Direções', duration: 8, xp: 80, completed: false, type: 'conversation' },
    { id: 'dl-15', title: 'Taxi Conversations', titlePt: 'Conversas no Táxi', duration: 6, xp: 65, completed: false, type: 'listening' },
    
    // Módulo 4: Saúde
    { id: 'dl-16', title: 'At the Hospital', titlePt: 'No Hospital', duration: 8, xp: 100, completed: false, type: 'conversation' },
    { id: 'dl-17', title: 'Describing Symptoms', titlePt: 'Descrevendo Sintomas', duration: 7, xp: 80, completed: false, type: 'vocabulary' },
    { id: 'dl-18', title: 'At the Pharmacy', titlePt: 'Na Farmácia', duration: 6, xp: 70, completed: false, type: 'conversation' },
    { id: 'dl-19', title: 'Making Appointments', titlePt: 'Marcando Consultas', duration: 7, xp: 75, completed: false, type: 'listening' },
    { id: 'dl-20', title: 'Emergency Situations', titlePt: 'Situações de Emergência', duration: 8, xp: 100, completed: false, type: 'conversation' },
    
    // Módulo 5: Comunicação
    { id: 'dl-21', title: 'Making Phone Calls', titlePt: 'Fazendo Ligações', duration: 6, xp: 70, completed: false, type: 'listening' },
    { id: 'dl-22', title: 'At the Bank', titlePt: 'No Banco', duration: 7, xp: 80, completed: false, type: 'vocabulary' },
    { id: 'dl-23', title: 'Post Office', titlePt: 'Correios', duration: 6, xp: 65, completed: false, type: 'conversation' },
    { id: 'dl-24', title: 'At the Restaurant', titlePt: 'No Restaurante', duration: 8, xp: 90, completed: false, type: 'conversation' },
    { id: 'dl-25', title: 'Social Conversations', titlePt: 'Conversas Sociais', duration: 7, xp: 75, completed: false, type: 'conversation' },
  ],
  
  'work-factory': [
    // Módulo 1: Começando no Trabalho
    { id: 'wf-1', title: 'Meeting Coworkers', titlePt: 'Conhecendo Colegas', duration: 5, xp: 50, completed: true, type: 'vocabulary' },
    { id: 'wf-2', title: 'Introducing Yourself', titlePt: 'Se Apresentando', duration: 5, xp: 50, completed: true, type: 'conversation' },
    { id: 'wf-3', title: 'Understanding Work Schedule', titlePt: 'Entendendo o Horário', duration: 6, xp: 60, completed: true, type: 'listening' },
    { id: 'wf-4', title: 'Break Room Basics', titlePt: 'Básico da Sala de Descanso', duration: 5, xp: 55, completed: true, type: 'vocabulary' },
    { id: 'wf-5', title: 'Asking Questions at Work', titlePt: 'Fazendo Perguntas no Trabalho', duration: 6, xp: 60, completed: true, type: 'conversation' },
    
    // Módulo 2: Segurança
    { id: 'wf-6', title: 'Safety Instructions', titlePt: 'Instruções de Segurança', duration: 8, xp: 100, completed: true, type: 'listening' },
    { id: 'wf-7', title: 'Safety Equipment', titlePt: 'Equipamentos de Segurança', duration: 7, xp: 80, completed: true, type: 'vocabulary' },
    { id: 'wf-8', title: 'Emergency Procedures', titlePt: 'Procedimentos de Emergência', duration: 8, xp: 90, completed: true, type: 'listening' },
    { id: 'wf-9', title: 'Reporting Accidents', titlePt: 'Reportando Acidentes', duration: 7, xp: 80, completed: false, current: true, type: 'conversation' },
    { id: 'wf-10', title: 'First Aid Vocabulary', titlePt: 'Vocabulário de Primeiros Socorros', duration: 6, xp: 70, completed: false, type: 'vocabulary' },
    
    // Módulo 3: Comunicação no Trabalho
    { id: 'wf-11', title: 'Reporting Problems', titlePt: 'Reportando Problemas', duration: 7, xp: 80, completed: false, type: 'conversation' },
    { id: 'wf-12', title: 'Asking for Help', titlePt: 'Pedindo Ajuda', duration: 6, xp: 65, completed: false, type: 'conversation' },
    { id: 'wf-13', title: 'Following Instructions', titlePt: 'Seguindo Instruções', duration: 7, xp: 75, completed: false, type: 'listening' },
    { id: 'wf-14', title: 'Machine Vocabulary', titlePt: 'Vocabulário de Máquinas', duration: 8, xp: 85, completed: false, type: 'vocabulary' },
    { id: 'wf-15', title: 'Quality Control Terms', titlePt: 'Termos de Controle de Qualidade', duration: 7, xp: 80, completed: false, type: 'vocabulary' },
    
    // Módulo 4: Convivência
    { id: 'wf-16', title: 'Break Time Conversations', titlePt: 'Conversas no Intervalo', duration: 6, xp: 60, completed: false, type: 'conversation' },
    { id: 'wf-17', title: 'Talking About Weekends', titlePt: 'Falando Sobre Fim de Semana', duration: 5, xp: 55, completed: false, type: 'conversation' },
    { id: 'wf-18', title: 'Making Small Talk', titlePt: 'Conversa Informal', duration: 6, xp: 60, completed: false, type: 'conversation' },
    { id: 'wf-19', title: 'Apologizing & Excusing', titlePt: 'Pedindo Desculpas', duration: 5, xp: 55, completed: false, type: 'vocabulary' },
    { id: 'wf-20', title: 'Expressing Gratitude', titlePt: 'Expressando Gratidão', duration: 5, xp: 50, completed: false, type: 'vocabulary' },
    
    // Módulo 5: Avançado
    { id: 'wf-21', title: 'Overtime & Schedule Changes', titlePt: 'Hora Extra e Mudanças de Horário', duration: 7, xp: 75, completed: false, type: 'conversation' },
    { id: 'wf-22', title: 'Vacation Requests', titlePt: 'Pedindo Férias', duration: 6, xp: 70, completed: false, type: 'conversation' },
    { id: 'wf-23', title: 'Understanding Payslips', titlePt: 'Entendendo o Holerite', duration: 8, xp: 90, completed: false, type: 'vocabulary' },
    { id: 'wf-24', title: 'Team Meetings', titlePt: 'Reuniões de Equipe', duration: 8, xp: 95, completed: false, type: 'listening' },
    { id: 'wf-25', title: 'Giving Feedback', titlePt: 'Dando Feedback', duration: 7, xp: 80, completed: false, type: 'conversation' },
  ],
  
  'truck-logistics': [
    // Módulo 1: Básico de Entregas
    { id: 'tl-1', title: 'Delivery Vocabulary', titlePt: 'Vocabulário de Entregas', duration: 6, xp: 60, completed: true, type: 'vocabulary' },
    { id: 'tl-2', title: 'Types of Packages', titlePt: 'Tipos de Pacotes', duration: 5, xp: 55, completed: true, type: 'vocabulary' },
    { id: 'tl-3', title: 'Loading & Unloading', titlePt: 'Carga e Descarga', duration: 7, xp: 70, completed: true, type: 'vocabulary' },
    { id: 'tl-4', title: 'Delivery Confirmation', titlePt: 'Confirmação de Entrega', duration: 6, xp: 65, completed: true, type: 'conversation' },
    { id: 'tl-5', title: 'Customer Interactions', titlePt: 'Interação com Clientes', duration: 7, xp: 75, completed: false, current: true, type: 'conversation' },
    
    // Módulo 2: Navegação
    { id: 'tl-6', title: 'GPS & Directions', titlePt: 'GPS e Direções', duration: 7, xp: 70, completed: false, type: 'listening' },
    { id: 'tl-7', title: 'Reading Addresses', titlePt: 'Lendo Endereços', duration: 6, xp: 65, completed: false, type: 'vocabulary' },
    { id: 'tl-8', title: 'Asking for Directions', titlePt: 'Pedindo Direções', duration: 7, xp: 75, completed: false, type: 'conversation' },
    { id: 'tl-9', title: 'Traffic Vocabulary', titlePt: 'Vocabulário de Trânsito', duration: 6, xp: 60, completed: false, type: 'vocabulary' },
    { id: 'tl-10', title: 'Road Signs', titlePt: 'Placas de Trânsito', duration: 7, xp: 70, completed: false, type: 'vocabulary' },
    
    // Módulo 3: Armazém
    { id: 'tl-11', title: 'Warehouse Communication', titlePt: 'Comunicação no Armazém', duration: 8, xp: 85, completed: false, type: 'conversation' },
    { id: 'tl-12', title: 'Forklift Operations', titlePt: 'Operação de Empilhadeira', duration: 7, xp: 80, completed: false, type: 'vocabulary' },
    { id: 'tl-13', title: 'Inventory Terms', titlePt: 'Termos de Inventário', duration: 6, xp: 70, completed: false, type: 'vocabulary' },
    { id: 'tl-14', title: 'Shipping Documents', titlePt: 'Documentos de Envio', duration: 8, xp: 90, completed: false, type: 'listening' },
    { id: 'tl-15', title: 'Reporting Damaged Goods', titlePt: 'Reportando Produtos Danificados', duration: 7, xp: 80, completed: false, type: 'conversation' },
    
    // Módulo 4: Problemas e Soluções
    { id: 'tl-16', title: 'Delivery Problems', titlePt: 'Problemas de Entrega', duration: 8, xp: 85, completed: false, type: 'conversation' },
    { id: 'tl-17', title: 'Vehicle Issues', titlePt: 'Problemas com Veículo', duration: 7, xp: 80, completed: false, type: 'vocabulary' },
    { id: 'tl-18', title: 'Calling for Support', titlePt: 'Ligando para Suporte', duration: 7, xp: 75, completed: false, type: 'conversation' },
    { id: 'tl-19', title: 'Accident Reports', titlePt: 'Relatórios de Acidente', duration: 8, xp: 90, completed: false, type: 'vocabulary' },
    { id: 'tl-20', title: 'Gas Station Conversations', titlePt: 'Conversas no Posto', duration: 6, xp: 60, completed: false, type: 'conversation' },
    
    // Módulo 5: Avançado
    { id: 'tl-21', title: 'Route Planning', titlePt: 'Planejamento de Rotas', duration: 8, xp: 85, completed: false, type: 'vocabulary' },
    { id: 'tl-22', title: 'Time Management', titlePt: 'Gestão de Tempo', duration: 7, xp: 75, completed: false, type: 'listening' },
    { id: 'tl-23', title: 'Customs & Border', titlePt: 'Alfândega e Fronteira', duration: 9, xp: 100, completed: false, type: 'conversation' },
    { id: 'tl-24', title: 'Long Haul Vocabulary', titlePt: 'Vocabulário de Longa Distância', duration: 7, xp: 80, completed: false, type: 'vocabulary' },
    { id: 'tl-25', title: 'Professional Radio Communication', titlePt: 'Comunicação por Rádio', duration: 8, xp: 90, completed: false, type: 'listening' },
  ],
  
  'business': [
    // Módulo 1: Fundamentos de Negócios
    { id: 'bs-1', title: 'Business Greetings', titlePt: 'Cumprimentos de Negócios', duration: 5, xp: 50, completed: false, current: true, type: 'vocabulary' },
    { id: 'bs-2', title: 'Professional Introduction', titlePt: 'Apresentação Profissional', duration: 6, xp: 60, completed: false, type: 'conversation' },
    { id: 'bs-3', title: 'Business Cards Exchange', titlePt: 'Troca de Cartões de Visita', duration: 5, xp: 55, completed: false, type: 'conversation' },
    { id: 'bs-4', title: 'Office Vocabulary', titlePt: 'Vocabulário de Escritório', duration: 6, xp: 60, completed: false, type: 'vocabulary' },
    { id: 'bs-5', title: 'Company Departments', titlePt: 'Departamentos da Empresa', duration: 6, xp: 65, completed: false, type: 'vocabulary' },
    
    // Módulo 2: Comunicação Escrita
    { id: 'bs-6', title: 'Business Email Basics', titlePt: 'Básico de E-mail Corporativo', duration: 8, xp: 90, completed: false, type: 'vocabulary' },
    { id: 'bs-7', title: 'Email Greetings & Closings', titlePt: 'Saudações e Despedidas em E-mail', duration: 6, xp: 65, completed: false, type: 'vocabulary' },
    { id: 'bs-8', title: 'Requesting Information', titlePt: 'Solicitando Informações', duration: 7, xp: 75, completed: false, type: 'conversation' },
    { id: 'bs-9', title: 'Scheduling Meetings', titlePt: 'Agendando Reuniões', duration: 7, xp: 80, completed: false, type: 'conversation' },
    { id: 'bs-10', title: 'Follow-up Messages', titlePt: 'Mensagens de Acompanhamento', duration: 6, xp: 70, completed: false, type: 'vocabulary' },
    
    // Módulo 3: Reuniões
    { id: 'bs-11', title: 'Meeting Vocabulary', titlePt: 'Vocabulário de Reuniões', duration: 7, xp: 75, completed: false, type: 'vocabulary' },
    { id: 'bs-12', title: 'Starting a Meeting', titlePt: 'Iniciando uma Reunião', duration: 6, xp: 70, completed: false, type: 'listening' },
    { id: 'bs-13', title: 'Expressing Opinions', titlePt: 'Expressando Opiniões', duration: 7, xp: 80, completed: false, type: 'conversation' },
    { id: 'bs-14', title: 'Agreeing & Disagreeing', titlePt: 'Concordando e Discordando', duration: 6, xp: 70, completed: false, type: 'conversation' },
    { id: 'bs-15', title: 'Closing a Meeting', titlePt: 'Encerrando uma Reunião', duration: 6, xp: 65, completed: false, type: 'listening' },
    
    // Módulo 4: Apresentações
    { id: 'bs-16', title: 'Presentation Structure', titlePt: 'Estrutura de Apresentações', duration: 8, xp: 90, completed: false, type: 'vocabulary' },
    { id: 'bs-17', title: 'Opening a Presentation', titlePt: 'Abrindo uma Apresentação', duration: 7, xp: 80, completed: false, type: 'conversation' },
    { id: 'bs-18', title: 'Describing Charts & Data', titlePt: 'Descrevendo Gráficos e Dados', duration: 8, xp: 85, completed: false, type: 'vocabulary' },
    { id: 'bs-19', title: 'Handling Questions', titlePt: 'Lidando com Perguntas', duration: 7, xp: 80, completed: false, type: 'conversation' },
    { id: 'bs-20', title: 'Concluding a Presentation', titlePt: 'Concluindo uma Apresentação', duration: 6, xp: 70, completed: false, type: 'listening' },
    
    // Módulo 5: Negociações
    { id: 'bs-21', title: 'Negotiation Basics', titlePt: 'Básico de Negociações', duration: 8, xp: 90, completed: false, type: 'vocabulary' },
    { id: 'bs-22', title: 'Making Proposals', titlePt: 'Fazendo Propostas', duration: 7, xp: 85, completed: false, type: 'conversation' },
    { id: 'bs-23', title: 'Counter-offers', titlePt: 'Contra-propostas', duration: 7, xp: 80, completed: false, type: 'conversation' },
    { id: 'bs-24', title: 'Reaching Agreement', titlePt: 'Chegando a um Acordo', duration: 8, xp: 90, completed: false, type: 'conversation' },
    { id: 'bs-25', title: 'Business Dinner Etiquette', titlePt: 'Etiqueta de Jantar de Negócios', duration: 7, xp: 85, completed: false, type: 'conversation' },
  ],
};

// Lesson Content Templates - Used dynamically based on lesson ID
export const lessonContents = {
  // Daily Life - Greetings
  'dl-1': {
    id: 'dl-1',
    title: 'Greetings & Introductions',
    titlePt: 'Cumprimentos e Apresentações',
    track: 'daily-life',
    duration: 5,
    xp: 50,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Aprender a cumprimentar pessoas e se apresentar em inglês é o primeiro passo para se comunicar. Vamos aprender as expressões mais comuns.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'Hello', pt: 'Olá', audio: true },
          { en: 'Good morning', pt: 'Bom dia', audio: true },
          { en: 'Good afternoon', pt: 'Boa tarde', audio: true },
          { en: 'Good evening', pt: 'Boa noite (chegando)', audio: true },
          { en: 'Good night', pt: 'Boa noite (despedida)', audio: true },
          { en: 'Nice to meet you', pt: 'Prazer em conhecê-lo', audio: true },
          { en: 'My name is...', pt: 'Meu nome é...', audio: true },
          { en: 'I am from Brazil', pt: 'Sou do Brasil', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Person A', text: 'Hello! My name is Tanaka.', translation: 'Olá! Meu nome é Tanaka.' },
          { speaker: 'You', text: 'Hi! Nice to meet you. I\'m Carlos.', translation: 'Oi! Prazer em conhecê-lo. Sou Carlos.' },
          { speaker: 'Person A', text: 'Nice to meet you too! Where are you from?', translation: 'Prazer também! De onde você é?' },
          { speaker: 'You', text: 'I\'m from Brazil.', translation: 'Sou do Brasil.' },
          { speaker: 'Person A', text: 'Welcome to Japan!', translation: 'Bem-vindo ao Japão!' },
          { speaker: 'You', text: 'Thank you very much!', translation: 'Muito obrigado!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Ouça e repita as frases abaixo:',
        phrases: [
          { en: 'Hello, how are you?', pt: 'Olá, como você está?' },
          { en: 'I\'m fine, thank you.', pt: 'Estou bem, obrigado.' },
          { en: 'See you later!', pt: 'Até mais!' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'Como dizer "Bom dia" em inglês?', options: ['Good night', 'Good morning', 'Good evening', 'Good afternoon'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Nice to meet you" significa:', options: ['Até logo', 'Prazer em conhecê-lo', 'Bom dia', 'Obrigado'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como responder a "How are you?"', options: ['I\'m fine, thank you', 'Nice to meet you', 'Good morning', 'See you later'], correct: 0 },
      { id: 'q4', type: 'multiple-choice', question: '"I am from Brazil" significa:', options: ['Eu moro no Brasil', 'Sou do Brasil', 'Gosto do Brasil', 'Conheço o Brasil'], correct: 1 },
    ],
  },

  // Daily Life - Basic Questions
  'dl-2': {
    id: 'dl-2',
    title: 'Basic Questions',
    titlePt: 'Perguntas Básicas',
    track: 'daily-life',
    duration: 5,
    xp: 50,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Saber fazer e responder perguntas básicas é essencial para qualquer conversa. Vamos aprender as perguntas mais comuns do dia a dia.',
      },
      {
        type: 'vocabulary',
        title: 'Palavras Interrogativas',
        words: [
          { en: 'What?', pt: 'O quê?', audio: true },
          { en: 'Where?', pt: 'Onde?', audio: true },
          { en: 'When?', pt: 'Quando?', audio: true },
          { en: 'Why?', pt: 'Por quê?', audio: true },
          { en: 'How?', pt: 'Como?', audio: true },
          { en: 'Who?', pt: 'Quem?', audio: true },
          { en: 'How much?', pt: 'Quanto?', audio: true },
          { en: 'How many?', pt: 'Quantos?', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Person A', text: 'What is your name?', translation: 'Qual é o seu nome?' },
          { speaker: 'You', text: 'My name is Maria.', translation: 'Meu nome é Maria.' },
          { speaker: 'Person A', text: 'Where do you live?', translation: 'Onde você mora?' },
          { speaker: 'You', text: 'I live in Tokyo.', translation: 'Eu moro em Tóquio.' },
          { speaker: 'Person A', text: 'How old are you?', translation: 'Quantos anos você tem?' },
          { speaker: 'You', text: 'I am 30 years old.', translation: 'Eu tenho 30 anos.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Ouça e repita as perguntas:',
        phrases: [
          { en: 'What time is it?', pt: 'Que horas são?' },
          { en: 'Where is the station?', pt: 'Onde fica a estação?' },
          { en: 'How much does it cost?', pt: 'Quanto custa?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Where?" significa:', options: ['Quando?', 'Onde?', 'Por quê?', 'Como?'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como perguntar "Quanto custa?"', options: ['How many?', 'How much?', 'What price?', 'When cost?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"What is your name?" significa:', options: ['Quantos anos você tem?', 'Onde você mora?', 'Qual é o seu nome?', 'Como você está?'], correct: 2 },
    ],
  },

  // Daily Life - Numbers & Time
  'dl-3': {
    id: 'dl-3',
    title: 'Numbers & Time',
    titlePt: 'Números e Horas',
    track: 'daily-life',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Números e horas são usados constantemente. Vamos aprender a contar e dizer as horas em inglês.',
      },
      {
        type: 'vocabulary',
        title: 'Números de 1 a 20',
        words: [
          { en: 'One, Two, Three', pt: 'Um, Dois, Três', audio: true },
          { en: 'Four, Five, Six', pt: 'Quatro, Cinco, Seis', audio: true },
          { en: 'Seven, Eight, Nine', pt: 'Sete, Oito, Nove', audio: true },
          { en: 'Ten, Eleven, Twelve', pt: 'Dez, Onze, Doze', audio: true },
          { en: 'Twenty, Thirty, Forty', pt: 'Vinte, Trinta, Quarenta', audio: true },
          { en: 'Fifty, Hundred', pt: 'Cinquenta, Cem', audio: true },
        ],
      },
      {
        type: 'vocabulary',
        title: 'Horas',
        words: [
          { en: 'What time is it?', pt: 'Que horas são?', audio: true },
          { en: 'It\'s 3 o\'clock', pt: 'São 3 horas', audio: true },
          { en: 'It\'s half past 5', pt: 'São 5 e meia', audio: true },
          { en: 'It\'s quarter to 8', pt: 'São 15 para as 8', audio: true },
          { en: 'In the morning (AM)', pt: 'De manhã', audio: true },
          { en: 'In the afternoon (PM)', pt: 'À tarde', audio: true },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique dizer as horas:',
        phrases: [
          { en: 'It\'s 7:30 in the morning.', pt: 'São 7:30 da manhã.' },
          { en: 'The meeting is at 2 PM.', pt: 'A reunião é às 14h.' },
          { en: 'I wake up at 6 o\'clock.', pt: 'Eu acordo às 6 horas.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'Como se diz "15" em inglês?', options: ['Fifty', 'Thirteen', 'Fifteen', 'Five'], correct: 2 },
      { id: 'q2', type: 'multiple-choice', question: '"Half past 3" significa:', options: ['3:15', '3:30', '3:45', '3:00'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Twenty" é qual número?', options: ['12', '20', '22', '200'], correct: 1 },
    ],
  },

  // Daily Life - Days & Months
  'dl-4': {
    id: 'dl-4',
    title: 'Days & Months',
    titlePt: 'Dias e Meses',
    track: 'daily-life',
    duration: 5,
    xp: 50,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Saber os dias da semana e meses do ano é fundamental para agendar compromissos e entender datas.',
      },
      {
        type: 'vocabulary',
        title: 'Dias da Semana',
        words: [
          { en: 'Monday', pt: 'Segunda-feira', audio: true },
          { en: 'Tuesday', pt: 'Terça-feira', audio: true },
          { en: 'Wednesday', pt: 'Quarta-feira', audio: true },
          { en: 'Thursday', pt: 'Quinta-feira', audio: true },
          { en: 'Friday', pt: 'Sexta-feira', audio: true },
          { en: 'Saturday', pt: 'Sábado', audio: true },
          { en: 'Sunday', pt: 'Domingo', audio: true },
        ],
      },
      {
        type: 'vocabulary',
        title: 'Meses do Ano',
        words: [
          { en: 'January, February, March', pt: 'Janeiro, Fevereiro, Março', audio: true },
          { en: 'April, May, June', pt: 'Abril, Maio, Junho', audio: true },
          { en: 'July, August, September', pt: 'Julho, Agosto, Setembro', audio: true },
          { en: 'October, November, December', pt: 'Outubro, Novembro, Dezembro', audio: true },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique datas importantes:',
        phrases: [
          { en: 'Today is Monday.', pt: 'Hoje é segunda-feira.' },
          { en: 'My birthday is in July.', pt: 'Meu aniversário é em julho.' },
          { en: 'See you on Friday!', pt: 'Te vejo na sexta!' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Wednesday" é qual dia?', options: ['Segunda', 'Terça', 'Quarta', 'Quinta'], correct: 2 },
      { id: 'q2', type: 'multiple-choice', question: 'Qual é o primeiro mês do ano em inglês?', options: ['February', 'January', 'March', 'December'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Saturday" significa:', options: ['Sexta-feira', 'Sábado', 'Domingo', 'Segunda-feira'], correct: 1 },
    ],
  },

  // Daily Life - Polite Expressions
  'dl-5': {
    id: 'dl-5',
    title: 'Polite Expressions',
    titlePt: 'Expressões de Cortesia',
    track: 'daily-life',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'A cortesia é muito valorizada no Japão. Vamos aprender expressões educadas em inglês para causar uma boa impressão.',
      },
      {
        type: 'vocabulary',
        title: 'Expressões Essenciais',
        words: [
          { en: 'Please', pt: 'Por favor', audio: true },
          { en: 'Thank you', pt: 'Obrigado(a)', audio: true },
          { en: 'Thank you very much', pt: 'Muito obrigado(a)', audio: true },
          { en: 'You\'re welcome', pt: 'De nada', audio: true },
          { en: 'Excuse me', pt: 'Com licença / Desculpe', audio: true },
          { en: 'I\'m sorry', pt: 'Desculpe / Sinto muito', audio: true },
          { en: 'No problem', pt: 'Sem problema', audio: true },
          { en: 'Of course', pt: 'Claro / Com certeza', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Excuse me, can you help me?', translation: 'Com licença, você pode me ajudar?' },
          { speaker: 'Person', text: 'Of course! What do you need?', translation: 'Claro! Do que você precisa?' },
          { speaker: 'You', text: 'Where is the train station, please?', translation: 'Onde fica a estação de trem, por favor?' },
          { speaker: 'Person', text: 'It\'s straight ahead, on the left.', translation: 'É em frente, à esquerda.' },
          { speaker: 'You', text: 'Thank you very much!', translation: 'Muito obrigado!' },
          { speaker: 'Person', text: 'You\'re welcome!', translation: 'De nada!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique ser educado:',
        phrases: [
          { en: 'Could you please repeat that?', pt: 'Você poderia repetir, por favor?' },
          { en: 'I\'m sorry for being late.', pt: 'Desculpe pelo atraso.' },
          { en: 'Thank you for your help!', pt: 'Obrigado pela sua ajuda!' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'Como dizer "De nada" em inglês?', options: ['Thank you', 'Please', 'You\'re welcome', 'Excuse me'], correct: 2 },
      { id: 'q2', type: 'multiple-choice', question: '"Excuse me" é usado para:', options: ['Agradecer', 'Pedir licença ou desculpas', 'Dizer adeus', 'Cumprimentar'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Qual é a forma mais educada de pedir algo?', options: ['Give me!', 'I want!', 'Could you please...?', 'Now!'], correct: 2 },
    ],
  },

  // Daily Life - At the Convenience Store
  'dl-6': {
    id: 'dl-6',
    title: 'At the Convenience Store',
    titlePt: 'Na Loja de Conveniência',
    track: 'daily-life',
    duration: 7,
    xp: 75,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'As lojas de conveniência (konbini) são parte essencial da vida no Japão. Vamos aprender a se comunicar nelas em inglês.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário da Loja',
        words: [
          { en: 'convenience store', pt: 'loja de conveniência', audio: true },
          { en: 'cash register', pt: 'caixa', audio: true },
          { en: 'receipt', pt: 'recibo', audio: true },
          { en: 'plastic bag', pt: 'sacola plástica', audio: true },
          { en: 'change', pt: 'troco', audio: true },
          { en: 'price', pt: 'preço', audio: true },
          { en: 'snacks', pt: 'lanches', audio: true },
          { en: 'drinks', pt: 'bebidas', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Cashier', text: 'Hello! Do you need a bag?', translation: 'Olá! Precisa de sacola?' },
          { speaker: 'You', text: 'Yes, please.', translation: 'Sim, por favor.' },
          { speaker: 'Cashier', text: 'That will be 850 yen.', translation: 'Serão 850 ienes.' },
          { speaker: 'You', text: 'Here is 1000 yen.', translation: 'Aqui está 1000 ienes.' },
          { speaker: 'Cashier', text: 'Here\'s your change, 150 yen.', translation: 'Aqui está seu troco, 150 ienes.' },
          { speaker: 'You', text: 'Thank you!', translation: 'Obrigado!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases úteis na konbini:',
        phrases: [
          { en: 'I don\'t need a bag, thank you.', pt: 'Não preciso de sacola, obrigado.' },
          { en: 'Can I pay with card?', pt: 'Posso pagar com cartão?' },
          { en: 'Where are the drinks?', pt: 'Onde ficam as bebidas?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Receipt" significa:', options: ['Sacola', 'Recibo', 'Troco', 'Preço'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como pedir o troco em inglês?', options: ['My change, please', 'Give money', 'Price please', 'Bag please'], correct: 0 },
      { id: 'q3', type: 'multiple-choice', question: '"Do you need a bag?" significa:', options: ['Você quer troco?', 'Você precisa de sacola?', 'Você quer recibo?', 'Você quer pagar?'], correct: 1 },
    ],
  },

  // Daily Life - Shopping for Groceries
  'dl-7': {
    id: 'dl-7',
    title: 'Shopping for Groceries',
    titlePt: 'Comprando no Supermercado',
    track: 'daily-life',
    duration: 6,
    xp: 65,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Fazer compras no supermercado é uma atividade rotineira. Aprenda o vocabulário de alimentos e como pedir ajuda.',
      },
      {
        type: 'vocabulary',
        title: 'Alimentos',
        words: [
          { en: 'bread', pt: 'pão', audio: true },
          { en: 'milk', pt: 'leite', audio: true },
          { en: 'eggs', pt: 'ovos', audio: true },
          { en: 'rice', pt: 'arroz', audio: true },
          { en: 'meat', pt: 'carne', audio: true },
          { en: 'fish', pt: 'peixe', audio: true },
          { en: 'vegetables', pt: 'vegetais', audio: true },
          { en: 'fruits', pt: 'frutas', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Excuse me, where can I find the milk?', translation: 'Com licença, onde posso encontrar o leite?' },
          { speaker: 'Staff', text: 'It\'s in aisle 3, on the right.', translation: 'Está no corredor 3, à direita.' },
          { speaker: 'You', text: 'Thank you. Is this bread fresh?', translation: 'Obrigado. Este pão é fresco?' },
          { speaker: 'Staff', text: 'Yes, it was baked this morning.', translation: 'Sim, foi assado esta manhã.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases úteis no supermercado:',
        phrases: [
          { en: 'Where is the frozen food section?', pt: 'Onde é a seção de congelados?' },
          { en: 'How much is this?', pt: 'Quanto custa isso?' },
          { en: 'Do you have any discounts today?', pt: 'Vocês têm descontos hoje?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Vegetables" significa:', options: ['Frutas', 'Carnes', 'Vegetais', 'Bebidas'], correct: 2 },
      { id: 'q2', type: 'multiple-choice', question: 'Como perguntar onde fica algo?', options: ['What is this?', 'Where can I find...?', 'How much?', 'When is it?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Aisle" significa:', options: ['Prateleira', 'Corredor', 'Caixa', 'Saída'], correct: 1 },
    ],
  },

  // Daily Life - Asking for Prices
  'dl-8': {
    id: 'dl-8',
    title: 'Asking for Prices',
    titlePt: 'Perguntando Preços',
    track: 'daily-life',
    duration: 5,
    xp: 55,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Saber perguntar e entender preços é essencial para fazer compras. Vamos aprender a negociar e entender valores.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Preços',
        words: [
          { en: 'How much?', pt: 'Quanto?', audio: true },
          { en: 'It costs...', pt: 'Custa...', audio: true },
          { en: 'expensive', pt: 'caro', audio: true },
          { en: 'cheap', pt: 'barato', audio: true },
          { en: 'discount', pt: 'desconto', audio: true },
          { en: 'sale', pt: 'promoção', audio: true },
          { en: 'total', pt: 'total', audio: true },
          { en: 'tax', pt: 'imposto', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'How much is this shirt?', translation: 'Quanto custa esta camisa?' },
          { speaker: 'Seller', text: 'It\'s 3,000 yen.', translation: 'São 3.000 ienes.' },
          { speaker: 'You', text: 'That\'s a bit expensive. Is there a discount?', translation: 'É um pouco caro. Tem desconto?' },
          { speaker: 'Seller', text: 'Yes, it\'s 20% off today!', translation: 'Sim, hoje está com 20% de desconto!' },
          { speaker: 'You', text: 'Great! I\'ll take it.', translation: 'Ótimo! Vou levar.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases sobre preços:',
        phrases: [
          { en: 'Is this on sale?', pt: 'Isso está em promoção?' },
          { en: 'That\'s too expensive for me.', pt: 'Isso é muito caro para mim.' },
          { en: 'What\'s the total?', pt: 'Qual é o total?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Expensive" significa:', options: ['Barato', 'Caro', 'Grátis', 'Normal'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como perguntar o preço?', options: ['What time?', 'How much?', 'Where is?', 'Who is?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Discount" significa:', options: ['Desconto', 'Aumento', 'Imposto', 'Total'], correct: 0 },
    ],
  },

  // Daily Life - Payment Methods
  'dl-9': {
    id: 'dl-9',
    title: 'Payment Methods',
    titlePt: 'Formas de Pagamento',
    track: 'daily-life',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'No Japão existem várias formas de pagamento. Aprenda a perguntar e usar diferentes métodos de pagamento.',
      },
      {
        type: 'vocabulary',
        title: 'Métodos de Pagamento',
        words: [
          { en: 'cash', pt: 'dinheiro', audio: true },
          { en: 'credit card', pt: 'cartão de crédito', audio: true },
          { en: 'debit card', pt: 'cartão de débito', audio: true },
          { en: 'mobile payment', pt: 'pagamento por celular', audio: true },
          { en: 'IC card (Suica/Pasmo)', pt: 'cartão IC', audio: true },
          { en: 'contactless', pt: 'por aproximação', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Cashier', text: 'How would you like to pay?', translation: 'Como você gostaria de pagar?' },
          { speaker: 'You', text: 'Can I pay by credit card?', translation: 'Posso pagar com cartão de crédito?' },
          { speaker: 'Cashier', text: 'Yes, of course. Insert or tap your card.', translation: 'Sim, claro. Insira ou aproxime seu cartão.' },
          { speaker: 'You', text: 'I\'ll tap it. Here you go.', translation: 'Vou aproximar. Aqui está.' },
          { speaker: 'Cashier', text: 'Payment successful. Thank you!', translation: 'Pagamento aprovado. Obrigado!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases sobre pagamento:',
        phrases: [
          { en: 'Do you accept credit cards?', pt: 'Vocês aceitam cartão de crédito?' },
          { en: 'I\'ll pay in cash.', pt: 'Vou pagar em dinheiro.' },
          { en: 'Can I use Suica?', pt: 'Posso usar Suica?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Cash" significa:', options: ['Cartão', 'Dinheiro', 'Cheque', 'Crédito'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como perguntar se aceitam cartão?', options: ['Give me card', 'Do you accept cards?', 'Card now', 'Where card?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Contactless" significa:', options: ['Sem contato/aproximação', 'Com contato', 'Inserir', 'Digitar'], correct: 0 },
    ],
  },

  // Daily Life - Returning Items
  'dl-10': {
    id: 'dl-10',
    title: 'Returning Items',
    titlePt: 'Devolvendo Produtos',
    track: 'daily-life',
    duration: 7,
    xp: 70,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Às vezes precisamos devolver ou trocar produtos. Aprenda como fazer isso educadamente em inglês.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Devolução',
        words: [
          { en: 'return', pt: 'devolver', audio: true },
          { en: 'exchange', pt: 'trocar', audio: true },
          { en: 'refund', pt: 'reembolso', audio: true },
          { en: 'receipt', pt: 'recibo', audio: true },
          { en: 'defective', pt: 'defeituoso', audio: true },
          { en: 'wrong size', pt: 'tamanho errado', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I\'d like to return this item.', translation: 'Gostaria de devolver este item.' },
          { speaker: 'Staff', text: 'What\'s the problem with it?', translation: 'Qual é o problema?' },
          { speaker: 'You', text: 'It\'s the wrong size. I need a larger one.', translation: 'É o tamanho errado. Preciso de um maior.' },
          { speaker: 'Staff', text: 'Do you have the receipt?', translation: 'Você tem o recibo?' },
          { speaker: 'You', text: 'Yes, here it is.', translation: 'Sim, aqui está.' },
          { speaker: 'Staff', text: 'I can exchange it for you.', translation: 'Posso trocar para você.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases para devoluções:',
        phrases: [
          { en: 'This product is defective.', pt: 'Este produto está defeituoso.' },
          { en: 'Can I get a refund?', pt: 'Posso receber um reembolso?' },
          { en: 'I\'d like to exchange this for another color.', pt: 'Gostaria de trocar por outra cor.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Refund" significa:', options: ['Troca', 'Reembolso', 'Desconto', 'Compra'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como dizer "tamanho errado"?', options: ['Bad size', 'Wrong size', 'No size', 'Big size'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Defective" significa:', options: ['Perfeito', 'Novo', 'Defeituoso', 'Bonito'], correct: 2 },
    ],
  },

  // Daily Life - Taking the Train
  'dl-11': {
    id: 'dl-11',
    title: 'Taking the Train',
    titlePt: 'Pegando o Trem',
    track: 'daily-life',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'O sistema de trens no Japão é muito eficiente. Aprenda o vocabulário necessário para usar o trem.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário do Trem',
        words: [
          { en: 'train station', pt: 'estação de trem', audio: true },
          { en: 'platform', pt: 'plataforma', audio: true },
          { en: 'ticket', pt: 'passagem/bilhete', audio: true },
          { en: 'departure', pt: 'partida', audio: true },
          { en: 'arrival', pt: 'chegada', audio: true },
          { en: 'transfer', pt: 'baldeação', audio: true },
          { en: 'express train', pt: 'trem expresso', audio: true },
          { en: 'local train', pt: 'trem local', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Excuse me, which platform for Shibuya?', translation: 'Com licença, qual plataforma para Shibuya?' },
          { speaker: 'Staff', text: 'Platform 3. The train leaves in 5 minutes.', translation: 'Plataforma 3. O trem sai em 5 minutos.' },
          { speaker: 'You', text: 'Do I need to transfer?', translation: 'Preciso fazer baldeação?' },
          { speaker: 'Staff', text: 'No, it\'s a direct train.', translation: 'Não, é um trem direto.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases úteis no trem:',
        phrases: [
          { en: 'What time is the next train?', pt: 'Que horas é o próximo trem?' },
          { en: 'Is this the train to Tokyo?', pt: 'Este é o trem para Tóquio?' },
          { en: 'Where should I transfer?', pt: 'Onde devo fazer baldeação?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Platform" significa:', options: ['Bilhete', 'Plataforma', 'Estação', 'Saída'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Transfer" significa:', options: ['Chegada', 'Partida', 'Baldeação', 'Viagem'], correct: 2 },
      { id: 'q3', type: 'multiple-choice', question: 'Como perguntar qual plataforma?', options: ['Where train?', 'Which platform?', 'What station?', 'When train?'], correct: 1 },
    ],
  },

  // Daily Life - Bus Transportation
  'dl-12': {
    id: 'dl-12',
    title: 'Bus Transportation',
    titlePt: 'Transporte de Ônibus',
    track: 'daily-life',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Os ônibus são uma forma importante de transporte no Japão. Aprenda a usá-los com confiança.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário do Ônibus',
        words: [
          { en: 'bus stop', pt: 'ponto de ônibus', audio: true },
          { en: 'bus driver', pt: 'motorista de ônibus', audio: true },
          { en: 'bus fare', pt: 'tarifa do ônibus', audio: true },
          { en: 'next stop', pt: 'próxima parada', audio: true },
          { en: 'get on', pt: 'embarcar', audio: true },
          { en: 'get off', pt: 'desembarcar', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Does this bus go to the hospital?', translation: 'Este ônibus vai para o hospital?' },
          { speaker: 'Driver', text: 'Yes, it does. Get on, please.', translation: 'Sim, vai. Embarque, por favor.' },
          { speaker: 'You', text: 'How much is the fare?', translation: 'Quanto custa a passagem?' },
          { speaker: 'Driver', text: '220 yen. You pay when you get off.', translation: '220 ienes. Você paga quando desembarcar.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases úteis no ônibus:',
        phrases: [
          { en: 'Please tell me when to get off.', pt: 'Por favor, me avise quando descer.' },
          { en: 'Is this the right bus for the airport?', pt: 'Este é o ônibus certo para o aeroporto?' },
          { en: 'Can I pay with IC card?', pt: 'Posso pagar com cartão IC?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Bus stop" significa:', options: ['Ônibus parado', 'Ponto de ônibus', 'Ônibus cheio', 'Ônibus rápido'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Get off" significa:', options: ['Embarcar', 'Desembarcar', 'Esperar', 'Correr'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como perguntar se vai ao hospital?', options: ['Hospital bus?', 'Does this bus go to the hospital?', 'Bus hospital now?', 'Where hospital?'], correct: 1 },
    ],
  },

  // Daily Life - Buying Tickets
  'dl-13': {
    id: 'dl-13',
    title: 'Buying Tickets',
    titlePt: 'Comprando Passagens',
    track: 'daily-life',
    duration: 7,
    xp: 70,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Seja para trem, ônibus ou cinema, comprar passagens é uma habilidade essencial. Vamos praticar!',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Passagens',
        words: [
          { en: 'one-way ticket', pt: 'passagem só ida', audio: true },
          { en: 'round-trip ticket', pt: 'passagem ida e volta', audio: true },
          { en: 'ticket machine', pt: 'máquina de bilhetes', audio: true },
          { en: 'reserved seat', pt: 'assento reservado', audio: true },
          { en: 'non-reserved seat', pt: 'assento livre', audio: true },
          { en: 'ticket counter', pt: 'guichê de bilhetes', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I\'d like a ticket to Osaka, please.', translation: 'Quero uma passagem para Osaka, por favor.' },
          { speaker: 'Staff', text: 'One-way or round-trip?', translation: 'Só ida ou ida e volta?' },
          { speaker: 'You', text: 'Round-trip, please.', translation: 'Ida e volta, por favor.' },
          { speaker: 'Staff', text: 'Reserved or non-reserved seat?', translation: 'Assento reservado ou livre?' },
          { speaker: 'You', text: 'Reserved seat, please.', translation: 'Assento reservado, por favor.' },
          { speaker: 'Staff', text: 'That will be 28,000 yen.', translation: 'Serão 28.000 ienes.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases para comprar passagens:',
        phrases: [
          { en: 'Two tickets for the 3 PM show, please.', pt: 'Duas entradas para a sessão das 15h, por favor.' },
          { en: 'Is there a discount for students?', pt: 'Há desconto para estudantes?' },
          { en: 'Can I change my ticket?', pt: 'Posso trocar minha passagem?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Round-trip" significa:', options: ['Só ida', 'Ida e volta', 'Direto', 'Com paradas'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Reserved seat" significa:', options: ['Assento livre', 'Assento reservado', 'Sem assento', 'Assento na janela'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como pedir uma passagem?', options: ['Give ticket!', 'I\'d like a ticket, please.', 'Ticket now!', 'Where ticket?'], correct: 1 },
    ],
  },

  // Daily Life - Asking for Directions
  'dl-14': {
    id: 'dl-14',
    title: 'Asking for Directions',
    titlePt: 'Pedindo Direções',
    track: 'daily-life',
    duration: 8,
    xp: 80,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Se perder em uma cidade nova pode ser estressante. Aprenda a pedir e entender direções em inglês.',
      },
      {
        type: 'vocabulary',
        title: 'Direções',
        words: [
          { en: 'turn left', pt: 'vire à esquerda', audio: true },
          { en: 'turn right', pt: 'vire à direita', audio: true },
          { en: 'go straight', pt: 'siga em frente', audio: true },
          { en: 'next to', pt: 'ao lado de', audio: true },
          { en: 'across from', pt: 'em frente a', audio: true },
          { en: 'on the corner', pt: 'na esquina', audio: true },
          { en: 'block', pt: 'quarteirão', audio: true },
          { en: 'traffic light', pt: 'semáforo', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Excuse me, how do I get to the post office?', translation: 'Com licença, como chego ao correio?' },
          { speaker: 'Person', text: 'Go straight for two blocks.', translation: 'Siga em frente por dois quarteirões.' },
          { speaker: 'Person', text: 'Then turn left at the traffic light.', translation: 'Depois vire à esquerda no semáforo.' },
          { speaker: 'Person', text: 'It\'s on the right, next to the bank.', translation: 'Fica à direita, ao lado do banco.' },
          { speaker: 'You', text: 'Thank you so much!', translation: 'Muito obrigado!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases para direções:',
        phrases: [
          { en: 'Is it far from here?', pt: 'É longe daqui?' },
          { en: 'Can you show me on the map?', pt: 'Pode me mostrar no mapa?' },
          { en: 'Is it walking distance?', pt: 'Dá para ir a pé?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Turn left" significa:', options: ['Vire à direita', 'Vire à esquerda', 'Siga em frente', 'Volte'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Traffic light" significa:', options: ['Luz de trânsito/Semáforo', 'Poste de luz', 'Luz de carro', 'Placa de trânsito'], correct: 0 },
      { id: 'q3', type: 'multiple-choice', question: '"Go straight" significa:', options: ['Pare', 'Vire', 'Siga em frente', 'Corra'], correct: 2 },
    ],
  },

  // Daily Life - Taxi Conversations
  'dl-15': {
    id: 'dl-15',
    title: 'Taxi Conversations',
    titlePt: 'Conversas no Táxi',
    track: 'daily-life',
    duration: 6,
    xp: 65,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Táxis no Japão são seguros e convenientes. Aprenda a comunicar seu destino e entender o motorista.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário do Táxi',
        words: [
          { en: 'taxi', pt: 'táxi', audio: true },
          { en: 'taxi driver', pt: 'motorista de táxi', audio: true },
          { en: 'destination', pt: 'destino', audio: true },
          { en: 'meter', pt: 'taxímetro', audio: true },
          { en: 'fare', pt: 'tarifa', audio: true },
          { en: 'drop me off here', pt: 'me deixe aqui', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Hello, to Tokyo Station, please.', translation: 'Olá, para a Estação de Tóquio, por favor.' },
          { speaker: 'Driver', text: 'Tokyo Station, understood.', translation: 'Estação de Tóquio, entendido.' },
          { speaker: 'You', text: 'How long will it take?', translation: 'Quanto tempo vai levar?' },
          { speaker: 'Driver', text: 'About 20 minutes, depending on traffic.', translation: 'Cerca de 20 minutos, dependendo do trânsito.' },
          { speaker: 'You', text: 'Please drop me off at the main entrance.', translation: 'Por favor, me deixe na entrada principal.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases úteis no táxi:',
        phrases: [
          { en: 'Can you take me to this address?', pt: 'Pode me levar a este endereço?' },
          { en: 'Please use the meter.', pt: 'Por favor, use o taxímetro.' },
          { en: 'Keep the change.', pt: 'Fique com o troco.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Destination" significa:', options: ['Origem', 'Destino', 'Parada', 'Caminho'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como dizer "me deixe aqui"?', options: ['Stop here', 'Drop me off here', 'Go here', 'Stay here'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"How long will it take?" significa:', options: ['Quanto custa?', 'Onde é?', 'Quanto tempo vai levar?', 'Qual é o caminho?'], correct: 2 },
    ],
  },

  // At the Hospital - Full Content
  'dl-16': {
    id: 'dl-16',
    title: 'At the Hospital',
    titlePt: 'No Hospital',
    track: 'daily-life',
    duration: 8,
    xp: 100,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Você precisa ir ao hospital no Japão e quer explicar seus sintomas em inglês para o médico ou enfermeiro.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'headache', pt: 'dor de cabeça', audio: true },
          { en: 'fever', pt: 'febre', audio: true },
          { en: 'stomach pain', pt: 'dor de estômago', audio: true },
          { en: 'prescription', pt: 'receita médica', audio: true },
          { en: 'insurance card', pt: 'cartão do seguro', audio: true },
          { en: 'appointment', pt: 'consulta', audio: true },
          { en: 'cough', pt: 'tosse', audio: true },
          { en: 'sore throat', pt: 'dor de garganta', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Nurse', text: 'Good morning. Do you have an appointment?', translation: 'Bom dia. Você tem uma consulta marcada?' },
          { speaker: 'You', text: 'No, I don\'t. I\'m feeling very sick.', translation: 'Não, não tenho. Estou me sentindo muito mal.' },
          { speaker: 'Nurse', text: 'What are your symptoms?', translation: 'Quais são seus sintomas?' },
          { speaker: 'You', text: 'I have a bad headache and a fever.', translation: 'Estou com uma dor de cabeça forte e febre.' },
          { speaker: 'Nurse', text: 'How long have you been feeling this way?', translation: 'Há quanto tempo você está assim?' },
          { speaker: 'You', text: 'Since yesterday morning.', translation: 'Desde ontem de manhã.' },
          { speaker: 'Nurse', text: 'Do you have your insurance card?', translation: 'Você tem seu cartão do seguro?' },
          { speaker: 'You', text: 'Yes, here it is.', translation: 'Sim, aqui está.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Ouça e repita as frases abaixo:',
        phrases: [
          { en: 'I need to see a doctor.', pt: 'Preciso ver um médico.' },
          { en: 'I\'ve been feeling sick since yesterday.', pt: 'Estou me sentindo mal desde ontem.' },
          { en: 'Where is the nearest pharmacy?', pt: 'Onde fica a farmácia mais próxima?' },
          { en: 'I\'m allergic to penicillin.', pt: 'Sou alérgico a penicilina.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'Como você diz "dor de cabeça" em inglês?', options: ['Stomachache', 'Headache', 'Backache', 'Toothache'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Qual é a tradução de "I need to see a doctor"?', options: ['Preciso de um remédio', 'Preciso ver um médico', 'Preciso de ajuda', 'Preciso descansar'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Fever" significa:', options: ['Frio', 'Calor', 'Febre', 'Gripe'], correct: 2 },
      { id: 'q4', type: 'multiple-choice', question: '"Insurance card" significa:', options: ['Cartão de crédito', 'Cartão do banco', 'Cartão do seguro', 'Cartão de visita'], correct: 2 },
    ],
  },

  // Daily Life - Describing Symptoms
  'dl-17': {
    id: 'dl-17',
    title: 'Describing Symptoms',
    titlePt: 'Descrevendo Sintomas',
    track: 'daily-life',
    duration: 7,
    xp: 80,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Saber descrever seus sintomas corretamente é essencial para receber o tratamento adequado.',
      },
      {
        type: 'vocabulary',
        title: 'Sintomas Comuns',
        words: [
          { en: 'I feel dizzy', pt: 'Estou com tontura', audio: true },
          { en: 'I feel nauseous', pt: 'Estou enjoado', audio: true },
          { en: 'I have a runny nose', pt: 'Estou com coriza', audio: true },
          { en: 'My back hurts', pt: 'Minhas costas doem', audio: true },
          { en: 'I have chest pain', pt: 'Estou com dor no peito', audio: true },
          { en: 'I can\'t sleep', pt: 'Não consigo dormir', audio: true },
          { en: 'I have a rash', pt: 'Estou com erupção na pele', audio: true },
          { en: 'I\'m tired all the time', pt: 'Estou cansado o tempo todo', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo com Médico',
        conversation: [
          { speaker: 'Doctor', text: 'What brings you here today?', translation: 'O que traz você aqui hoje?' },
          { speaker: 'You', text: 'I\'ve been feeling very tired lately.', translation: 'Tenho me sentido muito cansado ultimamente.' },
          { speaker: 'Doctor', text: 'How long has this been going on?', translation: 'Há quanto tempo isso está acontecendo?' },
          { speaker: 'You', text: 'About two weeks.', translation: 'Cerca de duas semanas.' },
          { speaker: 'Doctor', text: 'Any other symptoms?', translation: 'Algum outro sintoma?' },
          { speaker: 'You', text: 'Yes, I also have headaches and feel dizzy sometimes.', translation: 'Sim, também tenho dores de cabeça e às vezes sinto tontura.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Descreva seus sintomas:',
        phrases: [
          { en: 'The pain is sharp and constant.', pt: 'A dor é aguda e constante.' },
          { en: 'It hurts when I move.', pt: 'Dói quando me movimento.' },
          { en: 'I\'ve had this pain for three days.', pt: 'Tenho essa dor há três dias.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"I feel dizzy" significa:', options: ['Estou com fome', 'Estou com tontura', 'Estou com sono', 'Estou com frio'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como dizer "Minhas costas doem"?', options: ['My head hurts', 'My back hurts', 'My leg hurts', 'My arm hurts'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Runny nose" significa:', options: ['Nariz entupido', 'Coriza', 'Espirro', 'Dor no nariz'], correct: 1 },
    ],
  },

  // Daily Life - At the Pharmacy
  'dl-18': {
    id: 'dl-18',
    title: 'At the Pharmacy',
    titlePt: 'Na Farmácia',
    track: 'daily-life',
    duration: 6,
    xp: 70,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Farmácias no Japão oferecem diversos medicamentos. Aprenda a pedir o que precisa.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário da Farmácia',
        words: [
          { en: 'medicine', pt: 'remédio/medicamento', audio: true },
          { en: 'pain reliever', pt: 'analgésico', audio: true },
          { en: 'cold medicine', pt: 'remédio para gripe', audio: true },
          { en: 'bandage', pt: 'curativo/bandagem', audio: true },
          { en: 'prescription', pt: 'receita médica', audio: true },
          { en: 'dosage', pt: 'dosagem', audio: true },
          { en: 'side effects', pt: 'efeitos colaterais', audio: true },
          { en: 'over-the-counter', pt: 'sem receita', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I need something for a headache.', translation: 'Preciso de algo para dor de cabeça.' },
          { speaker: 'Pharmacist', text: 'Do you have any allergies?', translation: 'Você tem alguma alergia?' },
          { speaker: 'You', text: 'No, I don\'t.', translation: 'Não, não tenho.' },
          { speaker: 'Pharmacist', text: 'This pain reliever works well. Take 2 tablets every 6 hours.', translation: 'Este analgésico funciona bem. Tome 2 comprimidos a cada 6 horas.' },
          { speaker: 'You', text: 'Are there any side effects?', translation: 'Há efeitos colaterais?' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases úteis na farmácia:',
        phrases: [
          { en: 'Do I need a prescription for this?', pt: 'Preciso de receita para isso?' },
          { en: 'How many times a day should I take this?', pt: 'Quantas vezes por dia devo tomar?' },
          { en: 'Can I take this with food?', pt: 'Posso tomar com comida?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Pain reliever" significa:', options: ['Vitamina', 'Analgésico', 'Antibiótico', 'Xarope'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Side effects" significa:', options: ['Benefícios', 'Dosagem', 'Efeitos colaterais', 'Ingredientes'], correct: 2 },
      { id: 'q3', type: 'multiple-choice', question: '"Over-the-counter" significa:', options: ['Muito caro', 'Sem receita', 'Com receita', 'Importado'], correct: 1 },
    ],
  },

  // Daily Life - Making Appointments
  'dl-19': {
    id: 'dl-19',
    title: 'Making Appointments',
    titlePt: 'Marcando Consultas',
    track: 'daily-life',
    duration: 7,
    xp: 75,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Marcar consultas por telefone ou presencialmente é uma habilidade importante. Vamos aprender!',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Agendamento',
        words: [
          { en: 'appointment', pt: 'consulta/agendamento', audio: true },
          { en: 'available', pt: 'disponível', audio: true },
          { en: 'schedule', pt: 'agendar/horário', audio: true },
          { en: 'cancel', pt: 'cancelar', audio: true },
          { en: 'reschedule', pt: 'remarcar', audio: true },
          { en: 'waiting room', pt: 'sala de espera', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo por Telefone',
        conversation: [
          { speaker: 'Receptionist', text: 'Good morning, Dr. Tanaka\'s office.', translation: 'Bom dia, consultório do Dr. Tanaka.' },
          { speaker: 'You', text: 'I\'d like to make an appointment, please.', translation: 'Gostaria de marcar uma consulta, por favor.' },
          { speaker: 'Receptionist', text: 'When would you like to come in?', translation: 'Quando você gostaria de vir?' },
          { speaker: 'You', text: 'Is tomorrow afternoon available?', translation: 'Amanhã à tarde está disponível?' },
          { speaker: 'Receptionist', text: 'Yes, we have 3 PM open. Does that work?', translation: 'Sim, temos 15h livre. Funciona para você?' },
          { speaker: 'You', text: 'Perfect! I\'ll be there.', translation: 'Perfeito! Estarei lá.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases para agendamentos:',
        phrases: [
          { en: 'I need to reschedule my appointment.', pt: 'Preciso remarcar minha consulta.' },
          { en: 'What time slots are available?', pt: 'Quais horários estão disponíveis?' },
          { en: 'I\'d like to cancel my appointment.', pt: 'Gostaria de cancelar minha consulta.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Available" significa:', options: ['Ocupado', 'Disponível', 'Fechado', 'Lotado'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Reschedule" significa:', options: ['Cancelar', 'Confirmar', 'Remarcar', 'Atrasar'], correct: 2 },
      { id: 'q3', type: 'multiple-choice', question: 'Como marcar uma consulta?', options: ['I want doctor', 'I\'d like to make an appointment', 'Doctor now please', 'Give me time'], correct: 1 },
    ],
  },

  // Daily Life - Emergency Situations
  'dl-20': {
    id: 'dl-20',
    title: 'Emergency Situations',
    titlePt: 'Situações de Emergência',
    track: 'daily-life',
    duration: 8,
    xp: 100,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Em emergências, saber se comunicar rapidamente pode salvar vidas. Aprenda frases essenciais.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Emergência',
        words: [
          { en: 'Help!', pt: 'Socorro!', audio: true },
          { en: 'Call an ambulance!', pt: 'Chame uma ambulância!', audio: true },
          { en: 'Fire!', pt: 'Fogo!', audio: true },
          { en: 'Police!', pt: 'Polícia!', audio: true },
          { en: 'Emergency', pt: 'Emergência', audio: true },
          { en: 'I need help', pt: 'Preciso de ajuda', audio: true },
          { en: 'It\'s urgent', pt: 'É urgente', audio: true },
          { en: 'accident', pt: 'acidente', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Ligando para Emergência',
        conversation: [
          { speaker: 'Operator', text: '119, what\'s your emergency?', translation: '119, qual é sua emergência?' },
          { speaker: 'You', text: 'I need an ambulance! Someone collapsed!', translation: 'Preciso de ambulância! Alguém desmaiou!' },
          { speaker: 'Operator', text: 'What\'s your location?', translation: 'Qual é sua localização?' },
          { speaker: 'You', text: 'Near Shibuya Station, in front of the convenience store.', translation: 'Perto da estação Shibuya, em frente à loja de conveniência.' },
          { speaker: 'Operator', text: 'Help is on the way. Stay on the line.', translation: 'A ajuda está a caminho. Fique na linha.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases de emergência:',
        phrases: [
          { en: 'Please call the police!', pt: 'Por favor, chame a polícia!' },
          { en: 'There\'s been an accident.', pt: 'Houve um acidente.' },
          { en: 'Someone needs medical help.', pt: 'Alguém precisa de ajuda médica.' },
          { en: 'Where is the nearest hospital?', pt: 'Onde é o hospital mais próximo?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'Qual número de emergência no Japão?', options: ['911', '119', '999', '112'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Call an ambulance!" significa:', options: ['Chame um táxi!', 'Chame uma ambulância!', 'Chame a polícia!', 'Chame um médico!'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como pedir socorro?', options: ['Help!', 'Hello!', 'Hi!', 'Hey!'], correct: 0 },
    ],
  },

  // Daily Life - Making Phone Calls
  'dl-21': {
    id: 'dl-21',
    title: 'Making Phone Calls',
    titlePt: 'Fazendo Ligações',
    track: 'daily-life',
    duration: 6,
    xp: 70,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Fazer ligações em inglês pode ser desafiador. Vamos aprender as frases mais comuns.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Telefone',
        words: [
          { en: 'Hello, this is...', pt: 'Alô, aqui é...', audio: true },
          { en: 'May I speak to...?', pt: 'Posso falar com...?', audio: true },
          { en: 'Please hold', pt: 'Por favor, aguarde', audio: true },
          { en: 'I\'ll call back later', pt: 'Ligo mais tarde', audio: true },
          { en: 'Wrong number', pt: 'Número errado', audio: true },
          { en: 'Leave a message', pt: 'Deixar um recado', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Hello, may I speak to Mr. Yamamoto?', translation: 'Alô, posso falar com Sr. Yamamoto?' },
          { speaker: 'Receptionist', text: 'Please hold. I\'ll transfer your call.', translation: 'Por favor, aguarde. Vou transferir sua ligação.' },
          { speaker: 'You', text: 'Thank you.', translation: 'Obrigado.' },
          { speaker: 'Mr. Yamamoto', text: 'Hello, Yamamoto speaking.', translation: 'Alô, Yamamoto falando.' },
          { speaker: 'You', text: 'Hi, this is Carlos from ABC Company.', translation: 'Oi, aqui é Carlos da empresa ABC.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases úteis ao telefone:',
        phrases: [
          { en: 'Could you repeat that, please?', pt: 'Poderia repetir, por favor?' },
          { en: 'Can I leave a message?', pt: 'Posso deixar um recado?' },
          { en: 'I\'m sorry, I can\'t hear you well.', pt: 'Desculpe, não consigo ouvir bem.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Please hold" significa:', options: ['Por favor, desligue', 'Por favor, aguarde', 'Por favor, ligue', 'Por favor, fale'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como perguntar por alguém?', options: ['Where is...?', 'May I speak to...?', 'Who is...?', 'What is...?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Wrong number" significa:', options: ['Número certo', 'Número errado', 'Bom número', 'Seu número'], correct: 1 },
    ],
  },

  // Daily Life - Ordering Food
  'dl-22': {
    id: 'dl-22',
    title: 'Ordering Food',
    titlePt: 'Pedindo Comida',
    track: 'daily-life',
    duration: 7,
    xp: 75,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Pedir comida em restaurantes é uma das situações mais comuns. Aprenda a fazer seu pedido com confiança!',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Restaurante',
        words: [
          { en: 'menu', pt: 'cardápio', audio: true },
          { en: 'appetizer', pt: 'entrada', audio: true },
          { en: 'main course', pt: 'prato principal', audio: true },
          { en: 'dessert', pt: 'sobremesa', audio: true },
          { en: 'beverage/drink', pt: 'bebida', audio: true },
          { en: 'bill/check', pt: 'conta', audio: true },
          { en: 'tip', pt: 'gorjeta', audio: true },
          { en: 'takeout/to go', pt: 'para viagem', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Waiter', text: 'Are you ready to order?', translation: 'Está pronto para pedir?' },
          { speaker: 'You', text: 'Yes, I\'d like the ramen, please.', translation: 'Sim, quero o ramen, por favor.' },
          { speaker: 'Waiter', text: 'Would you like anything to drink?', translation: 'Gostaria de algo para beber?' },
          { speaker: 'You', text: 'Just water, please.', translation: 'Só água, por favor.' },
          { speaker: 'Waiter', text: 'Anything else?', translation: 'Mais alguma coisa?' },
          { speaker: 'You', text: 'No, that\'s all. Thank you!', translation: 'Não, é só isso. Obrigado!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases no restaurante:',
        phrases: [
          { en: 'Can I see the menu, please?', pt: 'Posso ver o cardápio, por favor?' },
          { en: 'What do you recommend?', pt: 'O que você recomenda?' },
          { en: 'Can I have the bill, please?', pt: 'Pode trazer a conta, por favor?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Bill" ou "Check" significa:', options: ['Cardápio', 'Conta', 'Gorjeta', 'Pedido'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como pedir para ver o cardápio?', options: ['Give menu!', 'Can I see the menu?', 'Menu now!', 'Where menu?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Takeout" significa:', options: ['Comer no local', 'Para viagem', 'Entregar', 'Reservar'], correct: 1 },
    ],
  },

  // Daily Life - At the Bank
  'dl-23': {
    id: 'dl-23',
    title: 'At the Bank',
    titlePt: 'No Banco',
    track: 'daily-life',
    duration: 7,
    xp: 80,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Transações bancárias são essenciais no dia a dia. Aprenda o vocabulário necessário.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Bancário',
        words: [
          { en: 'bank account', pt: 'conta bancária', audio: true },
          { en: 'withdraw', pt: 'sacar', audio: true },
          { en: 'deposit', pt: 'depositar', audio: true },
          { en: 'transfer', pt: 'transferir', audio: true },
          { en: 'balance', pt: 'saldo', audio: true },
          { en: 'ATM', pt: 'caixa eletrônico', audio: true },
          { en: 'exchange rate', pt: 'taxa de câmbio', audio: true },
          { en: 'fee', pt: 'taxa', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I\'d like to withdraw some money.', translation: 'Gostaria de sacar dinheiro.' },
          { speaker: 'Teller', text: 'How much would you like to withdraw?', translation: 'Quanto você gostaria de sacar?' },
          { speaker: 'You', text: '50,000 yen, please.', translation: '50.000 ienes, por favor.' },
          { speaker: 'Teller', text: 'May I see your ID and bank card?', translation: 'Posso ver seu documento e cartão do banco?' },
          { speaker: 'You', text: 'Here you are.', translation: 'Aqui está.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases no banco:',
        phrases: [
          { en: 'I want to open a bank account.', pt: 'Quero abrir uma conta bancária.' },
          { en: 'What\'s my current balance?', pt: 'Qual é meu saldo atual?' },
          { en: 'I need to exchange money.', pt: 'Preciso trocar dinheiro.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Withdraw" significa:', options: ['Depositar', 'Sacar', 'Transferir', 'Trocar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Balance" significa:', options: ['Taxa', 'Saldo', 'Conta', 'Cartão'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"ATM" é:', options: ['Banco', 'Caixa eletrônico', 'Cartão', 'Conta'], correct: 1 },
    ],
  },

  // Daily Life - Weather Conversations
  'dl-24': {
    id: 'dl-24',
    title: 'Weather Conversations',
    titlePt: 'Conversas sobre o Tempo',
    track: 'daily-life',
    duration: 5,
    xp: 55,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Falar sobre o tempo é uma forma comum de iniciar conversas. Aprenda esse vocabulário útil!',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário do Clima',
        words: [
          { en: 'sunny', pt: 'ensolarado', audio: true },
          { en: 'cloudy', pt: 'nublado', audio: true },
          { en: 'rainy', pt: 'chuvoso', audio: true },
          { en: 'snowy', pt: 'com neve', audio: true },
          { en: 'hot', pt: 'quente', audio: true },
          { en: 'cold', pt: 'frio', audio: true },
          { en: 'windy', pt: 'ventando', audio: true },
          { en: 'humid', pt: 'úmido', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Person', text: 'Nice weather today, isn\'t it?', translation: 'Bom tempo hoje, não é?' },
          { speaker: 'You', text: 'Yes, it\'s beautiful! Sunny and warm.', translation: 'Sim, está lindo! Ensolarado e quente.' },
          { speaker: 'Person', text: 'I heard it might rain tomorrow.', translation: 'Ouvi que pode chover amanhã.' },
          { speaker: 'You', text: 'Really? I should bring an umbrella.', translation: 'Sério? Devo trazer um guarda-chuva.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases sobre o tempo:',
        phrases: [
          { en: 'What\'s the weather like today?', pt: 'Como está o tempo hoje?' },
          { en: 'It\'s really hot today!', pt: 'Está muito quente hoje!' },
          { en: 'I hope it doesn\'t rain.', pt: 'Espero que não chova.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Cloudy" significa:', options: ['Ensolarado', 'Nublado', 'Chuvoso', 'Ventando'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como perguntar sobre o tempo?', options: ['What time is it?', 'What\'s the weather like?', 'Where is weather?', 'When is weather?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Humid" significa:', options: ['Seco', 'Úmido', 'Frio', 'Quente'], correct: 1 },
    ],
  },

  // Daily Life - Making Small Talk
  'dl-25': {
    id: 'dl-25',
    title: 'Making Small Talk',
    titlePt: 'Conversas Casuais',
    track: 'daily-life',
    duration: 6,
    xp: 65,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Small talk são conversas leves e casuais. São ótimas para fazer amigos e networking!',
      },
      {
        type: 'vocabulary',
        title: 'Frases para Small Talk',
        words: [
          { en: 'How was your weekend?', pt: 'Como foi seu fim de semana?', audio: true },
          { en: 'Did you watch the game?', pt: 'Você viu o jogo?', audio: true },
          { en: 'Any plans for the holiday?', pt: 'Algum plano para o feriado?', audio: true },
          { en: 'How long have you lived here?', pt: 'Há quanto tempo mora aqui?', audio: true },
          { en: 'What do you do for work?', pt: 'O que você faz de trabalho?', audio: true },
          { en: 'Do you have any hobbies?', pt: 'Você tem hobbies?', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Colleague', text: 'How was your weekend?', translation: 'Como foi seu fim de semana?' },
          { speaker: 'You', text: 'It was great! I went to Mount Fuji.', translation: 'Foi ótimo! Fui ao Monte Fuji.' },
          { speaker: 'Colleague', text: 'Wow, that sounds amazing! How was it?', translation: 'Uau, parece incrível! Como foi?' },
          { speaker: 'You', text: 'Beautiful! The view was breathtaking.', translation: 'Lindo! A vista era de tirar o fôlego.' },
          { speaker: 'Colleague', text: 'I\'d love to go there someday.', translation: 'Adoraria ir lá um dia.' },
          { speaker: 'You', text: 'You should! I can give you some tips.', translation: 'Deveria! Posso te dar algumas dicas.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases para conversas casuais:',
        phrases: [
          { en: 'That\'s interesting! Tell me more.', pt: 'Que interessante! Me conte mais.' },
          { en: 'I totally agree with you.', pt: 'Concordo totalmente com você.' },
          { en: 'It was nice talking to you!', pt: 'Foi bom conversar com você!' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'O que é "small talk"?', options: ['Falar baixo', 'Conversa casual/leve', 'Falar pouco', 'Conversa importante'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"How was your weekend?" é uma pergunta sobre:', options: ['Trabalho', 'Fim de semana', 'Família', 'Dinheiro'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Do you have any hobbies?" pergunta sobre:', options: ['Trabalho', 'Família', 'Passatempos', 'Dinheiro'], correct: 2 },
    ],
  },

  // Work - Safety Instructions
  'wf-6': {
    id: 'wf-6',
    title: 'Safety Instructions',
    titlePt: 'Instruções de Segurança',
    track: 'work-factory',
    duration: 8,
    xp: 100,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Entender instruções de segurança é fundamental no ambiente de trabalho japonês. Vamos aprender o vocabulário essencial de segurança.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Segurança',
        words: [
          { en: 'safety glasses', pt: 'óculos de segurança', audio: true },
          { en: 'hard hat', pt: 'capacete', audio: true },
          { en: 'safety gloves', pt: 'luvas de segurança', audio: true },
          { en: 'emergency exit', pt: 'saída de emergência', audio: true },
          { en: 'fire extinguisher', pt: 'extintor de incêndio', audio: true },
          { en: 'first aid kit', pt: 'kit de primeiros socorros', audio: true },
          { en: 'warning sign', pt: 'placa de aviso', audio: true },
          { en: 'safety zone', pt: 'zona de segurança', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Supervisor', text: 'Always wear your safety glasses in this area.', translation: 'Sempre use óculos de segurança nesta área.' },
          { speaker: 'You', text: 'Where can I get safety glasses?', translation: 'Onde posso pegar óculos de segurança?' },
          { speaker: 'Supervisor', text: 'They are in the supply room.', translation: 'Eles estão na sala de suprimentos.' },
          { speaker: 'You', text: 'What about the hard hat?', translation: 'E o capacete?' },
          { speaker: 'Supervisor', text: 'You need that too. Safety first!', translation: 'Você precisa disso também. Segurança em primeiro lugar!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases importantes de segurança:',
        phrases: [
          { en: 'Where is the emergency exit?', pt: 'Onde é a saída de emergência?' },
          { en: 'I need a hard hat.', pt: 'Preciso de um capacete.' },
          { en: 'Be careful! It\'s dangerous.', pt: 'Cuidado! É perigoso.' },
          { en: 'Please follow the safety rules.', pt: 'Por favor, siga as regras de segurança.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Safety glasses" significa:', options: ['Óculos de sol', 'Óculos de segurança', 'Óculos de leitura', 'Lentes de contato'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como se diz "capacete" em inglês?', options: ['Helmet', 'Hard hat', 'Safety hat', 'Ambas B e C estão corretas'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Emergency exit" significa:', options: ['Entrada principal', 'Saída de emergência', 'Porta do escritório', 'Janela'], correct: 1 },
      { id: 'q4', type: 'multiple-choice', question: '"Be careful" significa:', options: ['Muito bem', 'Cuidado', 'Continue', 'Pare'], correct: 1 },
    ],
  },


  // Work Factory - All lessons
  'wf-1': {
    id: 'wf-1',
    title: 'Meeting Coworkers',
    titlePt: 'Conhecendo Colegas',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Conhecendo Colegas.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'coworker', pt: 'colega de trabalho', audio: true },
          { en: 'boss', pt: 'chefe', audio: true },
          { en: 'supervisor', pt: 'supervisor', audio: true },
          { en: 'shift', pt: 'turno', audio: true },
          { en: 'department', pt: 'departamento', audio: true },
          { en: 'team', pt: 'equipe', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Coworker', text: 'Hi! Are you new here?', translation: 'Oi! Você é novo aqui?' },
          { speaker: 'You', text: 'Yes, today is my first day.', translation: 'Sim, hoje é meu primeiro dia.' },
          { speaker: 'Coworker', text: 'Welcome! I am Tanaka. What is your name?', translation: 'Bem-vindo! Sou Tanaka. Qual é o seu nome?' },
          { speaker: 'You', text: 'Nice to meet you. I am Carlos.', translation: 'Prazer em conhecê-lo. Sou Carlos.' },
          { speaker: 'Coworker', text: 'Which shift are you working?', translation: 'Qual turno você vai trabalhar?' },
          { speaker: 'You', text: 'The day shift, from 8 AM to 5 PM.', translation: 'O turno diurno, das 8h às 17h.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'Nice to meet you, I am the new employee.', pt: 'Prazer em conhecê-lo, sou o novo funcionário.' },
          { en: 'What department do you work in?', pt: 'Em qual departamento você trabalha?' },
          { en: 'I work in the production line.', pt: 'Eu trabalho na linha de produção.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Coworker" significa:', options: ['Chefe', 'Colega de trabalho', 'Cliente', 'Gerente'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como dizer "turno" em inglês?', options: ['Turn', 'Shift', 'Work', 'Time'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Department" significa:', options: ['Apartamento', 'Departamento', 'Partido', 'Divisão'], correct: 1 },
    ],
  },
  'wf-2': {
    id: 'wf-2',
    title: 'Introducing Yourself',
    titlePt: 'Se Apresentando',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Se Apresentando.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'I am from Brazil', pt: 'Sou do Brasil', audio: true },
          { en: 'I work as...', pt: 'Eu trabalho como...', audio: true },
          { en: 'factory worker', pt: 'trabalhador de fábrica', audio: true },
          { en: 'operator', pt: 'operador', audio: true },
          { en: 'years of experience', pt: 'anos de experiência', audio: true },
          { en: 'pleased to meet you', pt: 'prazer em conhecê-lo', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Supervisor', text: 'Please introduce yourself to the team.', translation: 'Por favor, apresente-se para a equipe.' },
          { speaker: 'You', text: 'Hello everyone. My name is Maria.', translation: 'Olá a todos. Meu nome é Maria.' },
          { speaker: 'You', text: 'I am from Brazil and I have 3 years of experience.', translation: 'Sou do Brasil e tenho 3 anos de experiência.' },
          { speaker: 'You', text: 'I used to work in a car parts factory.', translation: 'Eu trabalhava em uma fábrica de peças de carro.' },
          { speaker: 'Team', text: 'Welcome to the team!', translation: 'Bem-vinda à equipe!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'I have been working here for 2 months.', pt: 'Eu trabalho aqui há 2 meses.' },
          { en: 'My previous job was at a food factory.', pt: 'Meu emprego anterior era em uma fábrica de alimentos.' },
          { en: 'I am looking forward to working with you.', pt: 'Estou ansioso para trabalhar com vocês.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'Como dizer "trabalhador de fábrica"?', options: ['Factory worker', 'Work factory', 'Factory job', 'Job worker'], correct: 0 },
      { id: 'q2', type: 'multiple-choice', question: '"I am looking forward to" significa:', options: ['Estou olhando para frente', 'Estou ansioso para', 'Estou atrasado', 'Estou cansado'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Years of experience" significa:', options: ['Anos de estudo', 'Anos de experiência', 'Anos de trabalho', 'Anos de vida'], correct: 1 },
    ],
  },
  'wf-3': {
    id: 'wf-3',
    title: 'Understanding Work Schedule',
    titlePt: 'Entendendo o Horário',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Entendendo o Horário.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'work schedule', pt: 'horário de trabalho', audio: true },
          { en: 'day shift', pt: 'turno diurno', audio: true },
          { en: 'night shift', pt: 'turno noturno', audio: true },
          { en: 'overtime', pt: 'hora extra', audio: true },
          { en: 'break time', pt: 'horário de intervalo', audio: true },
          { en: 'punch in/out', pt: 'bater ponto', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Supervisor', text: 'Let me explain the work schedule.', translation: 'Deixe-me explicar o horário de trabalho.' },
          { speaker: 'Supervisor', text: 'Day shift is from 8 AM to 5 PM.', translation: 'O turno diurno é das 8h às 17h.' },
          { speaker: 'You', text: 'When is the lunch break?', translation: 'Quando é o intervalo de almoço?' },
          { speaker: 'Supervisor', text: 'Lunch is from 12 to 1 PM.', translation: 'O almoço é das 12h às 13h.' },
          { speaker: 'You', text: 'Do I need to punch in every day?', translation: 'Preciso bater ponto todo dia?' },
          { speaker: 'Supervisor', text: 'Yes, always punch in when you arrive.', translation: 'Sim, sempre bata ponto quando chegar.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'What time does my shift start?', pt: 'A que horas começa meu turno?' },
          { en: 'Is there overtime this week?', pt: 'Tem hora extra esta semana?' },
          { en: 'I need to check my schedule.', pt: 'Preciso verificar minha escala.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Night shift" significa:', options: ['Turno da tarde', 'Turno noturno', 'Turno da manhã', 'Turno duplo'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como perguntar sobre hora extra?', options: ['Where overtime?', 'Is there overtime?', 'What overtime?', 'Overtime please'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Punch in" significa:', options: ['Socar', 'Bater ponto', 'Entrar', 'Sair'], correct: 1 },
    ],
  },
  'wf-4': {
    id: 'wf-4',
    title: 'Break Room Basics',
    titlePt: 'Básico da Sala de Descanso',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Básico da Sala de Descanso.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'break room', pt: 'sala de descanso', audio: true },
          { en: 'vending machine', pt: 'máquina de vendas', audio: true },
          { en: 'microwave', pt: 'micro-ondas', audio: true },
          { en: 'locker', pt: 'armário/locker', audio: true },
          { en: 'restroom', pt: 'banheiro', audio: true },
          { en: 'drinking water', pt: 'água potável', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Excuse me, where is the break room?', translation: 'Com licença, onde é a sala de descanso?' },
          { speaker: 'Coworker', text: 'It is on the second floor, near the restrooms.', translation: 'É no segundo andar, perto dos banheiros.' },
          { speaker: 'You', text: 'Is there a microwave I can use?', translation: 'Tem micro-ondas que posso usar?' },
          { speaker: 'Coworker', text: 'Yes, and there is also a vending machine.', translation: 'Sim, e também tem uma máquina de vendas.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'Where can I get drinking water?', pt: 'Onde posso pegar água?' },
          { en: 'My locker is number 42.', pt: 'Meu armário é o número 42.' },
          { en: 'The vending machine is empty.', pt: 'A máquina de vendas está vazia.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Break room" significa:', options: ['Sala quebrada', 'Sala de descanso', 'Sala de reunião', 'Sala de trabalho'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Vending machine" significa:', options: ['Máquina de lavar', 'Máquina de vendas', 'Máquina de café', 'Máquina de costura'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como perguntar onde é o banheiro?', options: ['What is restroom?', 'Where is the restroom?', 'When restroom?', 'How restroom?'], correct: 1 },
    ],
  },
  'wf-5': {
    id: 'wf-5',
    title: 'Asking Questions at Work',
    titlePt: 'Fazendo Perguntas no Trabalho',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Fazendo Perguntas no Trabalho.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'How do I...?', pt: 'Como eu...?', audio: true },
          { en: 'Could you show me...?', pt: 'Você poderia me mostrar...?', audio: true },
          { en: 'I do not understand', pt: 'Eu não entendo', audio: true },
          { en: 'Could you repeat?', pt: 'Você poderia repetir?', audio: true },
          { en: 'What does this mean?', pt: 'O que isso significa?', audio: true },
          { en: 'Can you help me?', pt: 'Você pode me ajudar?', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Excuse me, could you help me?', translation: 'Com licença, você pode me ajudar?' },
          { speaker: 'Coworker', text: 'Sure, what do you need?', translation: 'Claro, do que você precisa?' },
          { speaker: 'You', text: 'How do I operate this machine?', translation: 'Como eu opero esta máquina?' },
          { speaker: 'Coworker', text: 'Let me show you. First, press this button.', translation: 'Deixe-me mostrar. Primeiro, aperte este botão.' },
          { speaker: 'You', text: 'Could you repeat that more slowly?', translation: 'Você poderia repetir mais devagar?' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'I am sorry, I do not understand.', pt: 'Desculpe, eu não entendo.' },
          { en: 'Could you speak more slowly, please?', pt: 'Você poderia falar mais devagar, por favor?' },
          { en: 'What should I do next?', pt: 'O que devo fazer em seguida?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'Como pedir para alguém repetir?', options: ['Repeat!', 'Could you repeat?', 'Say again now', 'What?'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"I do not understand" significa:', options: ['Eu não entendo', 'Eu entendo', 'Eu sei', 'Eu vejo'], correct: 0 },
      { id: 'q3', type: 'multiple-choice', question: 'Qual é a forma mais educada de pedir ajuda?', options: ['Help me!', 'I need help now', 'Could you help me?', 'You help'], correct: 2 },
    ],
  },
  'wf-7': {
    id: 'wf-7',
    title: 'Safety Equipment',
    titlePt: 'Equipamentos de Segurança',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Equipamentos de Segurança.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'safety helmet', pt: 'capacete de segurança', audio: true },
          { en: 'safety glasses', pt: 'óculos de segurança', audio: true },
          { en: 'gloves', pt: 'luvas', audio: true },
          { en: 'safety shoes', pt: 'sapatos de segurança', audio: true },
          { en: 'ear plugs', pt: 'protetores de ouvido', audio: true },
          { en: 'safety vest', pt: 'colete de segurança', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Supervisor', text: 'You must wear safety equipment at all times.', translation: 'Você deve usar equipamentos de segurança o tempo todo.' },
          { speaker: 'You', text: 'What equipment do I need?', translation: 'Quais equipamentos eu preciso?' },
          { speaker: 'Supervisor', text: 'Safety glasses, gloves, and safety shoes.', translation: 'Óculos de segurança, luvas e sapatos de segurança.' },
          { speaker: 'You', text: 'Where can I get them?', translation: 'Onde posso pegá-los?' },
          { speaker: 'Supervisor', text: 'At the supply room, first floor.', translation: 'Na sala de suprimentos, primeiro andar.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'Do not forget your safety helmet!', pt: 'Não esqueça seu capacete!' },
          { en: 'I need new gloves, these are torn.', pt: 'Preciso de luvas novas, estas estão rasgadas.' },
          { en: 'Always wear your ear plugs in this area.', pt: 'Sempre use protetores de ouvido nesta área.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Safety glasses" significa:', options: ['Copos de segurança', 'Óculos de segurança', 'Óculos de sol', 'Vidros de segurança'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Gloves" significa:', options: ['Globos', 'Luvas', 'Chapéus', 'Botas'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como dizer "capacete de segurança"?', options: ['Safe helmet', 'Security helmet', 'Safety helmet', 'Protect helmet'], correct: 2 },
    ],
  },
  'wf-8': {
    id: 'wf-8',
    title: 'Emergency Procedures',
    titlePt: 'Procedimentos de Emergência',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Procedimentos de Emergência.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'emergency exit', pt: 'saída de emergência', audio: true },
          { en: 'fire alarm', pt: 'alarme de incêndio', audio: true },
          { en: 'fire extinguisher', pt: 'extintor de incêndio', audio: true },
          { en: 'first aid kit', pt: 'kit de primeiros socorros', audio: true },
          { en: 'evacuation', pt: 'evacuação', audio: true },
          { en: 'assembly point', pt: 'ponto de encontro', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Safety Officer', text: 'When you hear the fire alarm, stop working immediately.', translation: 'Quando ouvir o alarme de incêndio, pare de trabalhar imediatamente.' },
          { speaker: 'Safety Officer', text: 'Go to the nearest emergency exit.', translation: 'Vá para a saída de emergência mais próxima.' },
          { speaker: 'You', text: 'Where is the assembly point?', translation: 'Onde é o ponto de encontro?' },
          { speaker: 'Safety Officer', text: 'In the parking lot, section A.', translation: 'No estacionamento, seção A.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'The emergency exit is over there.', pt: 'A saída de emergência é ali.' },
          { en: 'Do you know where the fire extinguisher is?', pt: 'Você sabe onde está o extintor?' },
          { en: 'We need to evacuate the building.', pt: 'Precisamos evacuar o prédio.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Fire extinguisher" significa:', options: ['Extintor de incêndio', 'Alarme de incêndio', 'Saída de incêndio', 'Mangueira de incêndio'], correct: 0 },
      { id: 'q2', type: 'multiple-choice', question: '"Assembly point" significa:', options: ['Ponto de montagem', 'Ponto de encontro', 'Ponto de saída', 'Ponto de entrada'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'O que fazer quando ouvir o alarme de incêndio?', options: ['Continuar trabalhando', 'Correr para qualquer lugar', 'Ir para a saída de emergência', 'Ligar para casa'], correct: 2 },
    ],
  },
  'wf-9': {
    id: 'wf-9',
    title: 'Reporting Accidents',
    titlePt: 'Reportando Acidentes',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Reportando Acidentes.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'accident', pt: 'acidente', audio: true },
          { en: 'injury', pt: 'lesão/ferimento', audio: true },
          { en: 'report', pt: 'reportar/relatar', audio: true },
          { en: 'incident', pt: 'incidente', audio: true },
          { en: 'witness', pt: 'testemunha', audio: true },
          { en: 'safety officer', pt: 'responsável pela segurança', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I need to report an accident.', translation: 'Preciso reportar um acidente.' },
          { speaker: 'Safety Officer', text: 'What happened?', translation: 'O que aconteceu?' },
          { speaker: 'You', text: 'A coworker fell and hurt his arm.', translation: 'Um colega caiu e machucou o braço.' },
          { speaker: 'Safety Officer', text: 'Where did it happen?', translation: 'Onde aconteceu?' },
          { speaker: 'You', text: 'Near the loading area, about 10 minutes ago.', translation: 'Perto da área de carga, há cerca de 10 minutos.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'There was an accident in section B.', pt: 'Houve um acidente na seção B.' },
          { en: 'Someone got injured by a machine.', pt: 'Alguém se machucou com uma máquina.' },
          { en: 'I witnessed what happened.', pt: 'Eu testemunhei o que aconteceu.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Injury" significa:', options: ['Lesão', 'Injúria', 'Insulto', 'Incidente'], correct: 0 },
      { id: 'q2', type: 'multiple-choice', question: 'Como reportar um acidente?', options: ['Accident happened!', 'I need to report an accident', 'Help accident!', 'Accident!'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Witness" significa:', options: ['Testemunha', 'Vítima', 'Culpado', 'Suspeito'], correct: 0 },
    ],
  },
  'wf-10': {
    id: 'wf-10',
    title: 'First Aid Vocabulary',
    titlePt: 'Vocabulário de Primeiros Socorros',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Vocabulário de Primeiros Socorros.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'bandage', pt: 'bandagem/curativo', audio: true },
          { en: 'cut', pt: 'corte', audio: true },
          { en: 'burn', pt: 'queimadura', audio: true },
          { en: 'bleeding', pt: 'sangramento', audio: true },
          { en: 'pain', pt: 'dor', audio: true },
          { en: 'medicine', pt: 'remédio', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I cut my finger. Where is the first aid kit?', translation: 'Cortei meu dedo. Onde está o kit de primeiros socorros?' },
          { speaker: 'Coworker', text: 'It is on the wall near the entrance.', translation: 'Está na parede perto da entrada.' },
          { speaker: 'You', text: 'I need a bandage.', translation: 'Preciso de um curativo.' },
          { speaker: 'Coworker', text: 'Is it bleeding a lot?', translation: 'Está sangrando muito?' },
          { speaker: 'You', text: 'No, it is just a small cut.', translation: 'Não, é só um corte pequeno.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'I burned my hand. Do you have any cream?', pt: 'Queimei minha mão. Você tem algum creme?' },
          { en: 'The bleeding stopped.', pt: 'O sangramento parou.' },
          { en: 'I need to sit down, I feel dizzy.', pt: 'Preciso sentar, estou tonto.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Bandage" significa:', options: ['Bandeira', 'Bandagem', 'Banda', 'Bando'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Bleeding" significa:', options: ['Sangrando', 'Respirando', 'Correndo', 'Chorando'], correct: 0 },
      { id: 'q3', type: 'multiple-choice', question: 'Como dizer "queimadura"?', options: ['Hot', 'Fire', 'Burn', 'Heat'], correct: 2 },
    ],
  },
  'wf-11': {
    id: 'wf-11',
    title: 'Reporting Problems',
    titlePt: 'Reportando Problemas',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Reportando Problemas.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'problem', pt: 'problema', audio: true },
          { en: 'broken', pt: 'quebrado', audio: true },
          { en: 'not working', pt: 'não está funcionando', audio: true },
          { en: 'defect', pt: 'defeito', audio: true },
          { en: 'maintenance', pt: 'manutenção', audio: true },
          { en: 'repair', pt: 'consertar', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Excuse me, this machine is not working.', translation: 'Com licença, esta máquina não está funcionando.' },
          { speaker: 'Supervisor', text: 'What is the problem?', translation: 'Qual é o problema?' },
          { speaker: 'You', text: 'It makes a strange noise and stops.', translation: 'Ela faz um barulho estranho e para.' },
          { speaker: 'Supervisor', text: 'I will call maintenance right away.', translation: 'Vou chamar a manutenção imediatamente.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'The conveyor belt is broken.', pt: 'A esteira está quebrada.' },
          { en: 'We need to stop production.', pt: 'Precisamos parar a produção.' },
          { en: 'Has anyone called maintenance?', pt: 'Alguém chamou a manutenção?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Broken" significa:', options: ['Aberto', 'Fechado', 'Quebrado', 'Novo'], correct: 2 },
      { id: 'q2', type: 'multiple-choice', question: 'Como dizer "não está funcionando"?', options: ['Is not working', 'Not working', 'No work', "Do not work"], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Maintenance" significa:', options: ['Principal', 'Manutenção', 'Importante', 'Mantimento'], correct: 1 },
    ],
  },
  'wf-12': {
    id: 'wf-12',
    title: 'Asking for Help',
    titlePt: 'Pedindo Ajuda',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Pedindo Ajuda.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'Can you help me?', pt: 'Você pode me ajudar?', audio: true },
          { en: 'I need assistance', pt: 'Preciso de ajuda', audio: true },
          { en: 'support', pt: 'apoio/suporte', audio: true },
          { en: 'together', pt: 'juntos', audio: true },
          { en: 'heavy', pt: 'pesado', audio: true },
          { en: 'lift', pt: 'levantar', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Can you help me with this box?', translation: 'Você pode me ajudar com esta caixa?' },
          { speaker: 'Coworker', text: 'Sure! Is it heavy?', translation: 'Claro! É pesada?' },
          { speaker: 'You', text: 'Yes, I cannot lift it alone.', translation: 'Sim, não consigo levantar sozinho.' },
          { speaker: 'Coworker', text: 'Let us do it together.', translation: 'Vamos fazer juntos.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'I need some help over here!', pt: 'Preciso de ajuda aqui!' },
          { en: 'This is too heavy for one person.', pt: 'Isso é muito pesado para uma pessoa.' },
          { en: 'Could you give me a hand?', pt: 'Você poderia me dar uma mão?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: 'Como pedir ajuda de forma educada?', options: ['Help!', 'Could you help me?', 'Help now!', 'You help'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Heavy" significa:', options: ['Leve', 'Pesado', 'Grande', 'Pequeno'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Lift" significa:', options: ['Elevador/Levantar', 'Abaixar', 'Deixar', 'Carregar'], correct: 0 },
    ],
  },
  'wf-13': {
    id: 'wf-13',
    title: 'Following Instructions',
    titlePt: 'Seguindo Instruções',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Seguindo Instruções.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'first', pt: 'primeiro', audio: true },
          { en: 'then', pt: 'então/depois', audio: true },
          { en: 'next', pt: 'próximo', audio: true },
          { en: 'finally', pt: 'finalmente', audio: true },
          { en: 'step', pt: 'passo/etapa', audio: true },
          { en: 'procedure', pt: 'procedimento', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Supervisor', text: 'Let me explain the procedure.', translation: 'Deixe-me explicar o procedimento.' },
          { speaker: 'Supervisor', text: 'First, check the materials.', translation: 'Primeiro, verifique os materiais.' },
          { speaker: 'Supervisor', text: 'Then, turn on the machine.', translation: 'Então, ligue a máquina.' },
          { speaker: 'Supervisor', text: 'Finally, press the start button.', translation: 'Finalmente, aperte o botão de iniciar.' },
          { speaker: 'You', text: 'I understand. Thank you.', translation: 'Entendi. Obrigado.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'What is the next step?', pt: 'Qual é o próximo passo?' },
          { en: 'Let me repeat the instructions.', pt: 'Deixe-me repetir as instruções.' },
          { en: 'Did I do it correctly?', pt: 'Eu fiz corretamente?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"First" significa:', options: ['Último', 'Primeiro', 'Segundo', 'Final'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Then" significa:', options: ['Antes', 'Agora', 'Então/Depois', 'Nunca'], correct: 2 },
      { id: 'q3', type: 'multiple-choice', question: '"Step" significa:', options: ['Escada', 'Passo', 'Parar', 'Pisar'], correct: 1 },
    ],
  },
  'wf-14': {
    id: 'wf-14',
    title: 'Machine Vocabulary',
    titlePt: 'Vocabulário de Máquinas',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Vocabulário de Máquinas.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'button', pt: 'botão', audio: true },
          { en: 'switch', pt: 'interruptor', audio: true },
          { en: 'screen', pt: 'tela', audio: true },
          { en: 'lever', pt: 'alavanca', audio: true },
          { en: 'conveyor belt', pt: 'esteira', audio: true },
          { en: 'control panel', pt: 'painel de controle', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Trainer', text: 'This is the control panel.', translation: 'Este é o painel de controle.' },
          { speaker: 'Trainer', text: 'The red button is for emergency stop.', translation: 'O botão vermelho é para parada de emergência.' },
          { speaker: 'You', text: 'What does this switch do?', translation: 'O que este interruptor faz?' },
          { speaker: 'Trainer', text: 'It controls the conveyor belt speed.', translation: 'Ele controla a velocidade da esteira.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'Press the green button to start.', pt: 'Aperte o botão verde para iniciar.' },
          { en: 'The machine has a touch screen.', pt: 'A máquina tem uma tela touch.' },
          { en: 'Pull this lever to release.', pt: 'Puxe esta alavanca para soltar.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Button" significa:', options: ['Bota', 'Botão', 'Boto', 'Batom'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Conveyor belt" significa:', options: ['Cinto de segurança', 'Esteira', 'Correia', 'Faixa'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Control panel" significa:', options: ['Controle remoto', 'Painel solar', 'Painel de controle', 'Painel de aviso'], correct: 2 },
    ],
  },
  'wf-15': {
    id: 'wf-15',
    title: 'Quality Control Terms',
    titlePt: 'Termos de Controle de Qualidade',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Termos de Controle de Qualidade.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'quality', pt: 'qualidade', audio: true },
          { en: 'inspection', pt: 'inspeção', audio: true },
          { en: 'defect', pt: 'defeito', audio: true },
          { en: 'standard', pt: 'padrão', audio: true },
          { en: 'reject', pt: 'rejeitar', audio: true },
          { en: 'approve', pt: 'aprovar', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'QC Inspector', text: 'We need to check the quality of these products.', translation: 'Precisamos verificar a qualidade destes produtos.' },
          { speaker: 'You', text: 'What should I look for?', translation: 'O que devo procurar?' },
          { speaker: 'QC Inspector', text: 'Any scratches, dents, or defects.', translation: 'Quaisquer arranhões, amassados ou defeitos.' },
          { speaker: 'You', text: 'What do I do if I find a defect?', translation: 'O que faço se encontrar um defeito?' },
          { speaker: 'QC Inspector', text: 'Put it in the reject bin.', translation: 'Coloque na caixa de rejeitados.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'This product does not meet the standard.', pt: 'Este produto não atende ao padrão.' },
          { en: 'All items passed inspection.', pt: 'Todos os itens passaram na inspeção.' },
          { en: 'There is a defect on this piece.', pt: 'Há um defeito nesta peça.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Quality" significa:', options: ['Quantidade', 'Qualidade', 'Qualquer', 'Quase'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Defect" significa:', options: ['Perfeito', 'Defeito', 'Efeito', 'Afeto'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Inspection" significa:', options: ['Inserção', 'Inspeção', 'Injeção', 'Inspiração'], correct: 1 },
    ],
  },
  'wf-16': {
    id: 'wf-16',
    title: 'Break Time Conversations',
    titlePt: 'Conversas no Intervalo',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Conversas no Intervalo.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'How are you?', pt: 'Como você está?', audio: true },
          { en: 'I am tired', pt: 'Estou cansado', audio: true },
          { en: 'hungry', pt: 'com fome', audio: true },
          { en: 'lunch', pt: 'almoço', audio: true },
          { en: 'coffee', pt: 'café', audio: true },
          { en: 'rest', pt: 'descansar', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Coworker', text: 'Hey, how are you today?', translation: 'Ei, como você está hoje?' },
          { speaker: 'You', text: 'I am a bit tired. It is been a long morning.', translation: 'Estou um pouco cansado. Foi uma manhã longa.' },
          { speaker: 'Coworker', text: 'Same here. Do you want some coffee?', translation: 'Também. Você quer café?' },
          { speaker: 'You', text: 'Yes, please! That would be great.', translation: 'Sim, por favor! Seria ótimo.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'What did you bring for lunch?', pt: 'O que você trouxe para o almoço?' },
          { en: 'I need to rest a bit.', pt: 'Preciso descansar um pouco.' },
          { en: 'This coffee is really good.', pt: 'Este café é muito bom.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"I am tired" significa:', options: ['Estou atrasado', 'Estou cansado', 'Estou com pressa', 'Estou feliz'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Hungry" significa:', options: ['Com sede', 'Com fome', 'Com sono', 'Com raiva'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como oferecer café a alguém?', options: ['Coffee?', 'Do you want some coffee?', 'You coffee', 'Give coffee'], correct: 1 },
    ],
  },
  'wf-17': {
    id: 'wf-17',
    title: 'Talking About Weekends',
    titlePt: 'Falando Sobre Fim de Semana',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Falando Sobre Fim de Semana.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'weekend', pt: 'fim de semana', audio: true },
          { en: 'plans', pt: 'planos', audio: true },
          { en: 'stayed home', pt: 'fiquei em casa', audio: true },
          { en: 'went out', pt: 'saí', audio: true },
          { en: 'family', pt: 'família', audio: true },
          { en: 'relaxed', pt: 'relaxei', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Coworker', text: 'How was your weekend?', translation: 'Como foi seu fim de semana?' },
          { speaker: 'You', text: 'It was good. I stayed home and relaxed.', translation: 'Foi bom. Fiquei em casa e relaxei.' },
          { speaker: 'Coworker', text: 'Nice! I went to the park with my family.', translation: 'Legal! Fui ao parque com minha família.' },
          { speaker: 'You', text: 'That sounds fun. Any plans for next weekend?', translation: 'Parece divertido. Algum plano pro próximo fim de semana?' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'I visited some friends this weekend.', pt: 'Visitei alguns amigos neste fim de semana.' },
          { en: 'Next weekend I will go shopping.', pt: 'No próximo fim de semana vou fazer compras.' },
          { en: 'I had a great weekend!', pt: 'Tive um ótimo fim de semana!' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Weekend" significa:', options: ['Semana', 'Fim de semana', 'Feriado', 'Férias'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como perguntar sobre o fim de semana?', options: ['Your weekend?', 'How was your weekend?', 'Weekend good?', 'What weekend?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"I stayed home" significa:', options: ['Fui para casa', 'Fiquei em casa', 'Saí de casa', 'Voltei para casa'], correct: 1 },
    ],
  },
  'wf-18': {
    id: 'wf-18',
    title: 'Making Small Talk',
    titlePt: 'Conversa Informal',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Conversa Informal.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'weather', pt: 'clima/tempo', audio: true },
          { en: 'hot', pt: 'quente', audio: true },
          { en: 'cold', pt: 'frio', audio: true },
          { en: 'busy', pt: 'ocupado', audio: true },
          { en: 'nice', pt: 'legal/bom', audio: true },
          { en: 'how about you?', pt: 'e você?', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Nice weather today, is not it?', translation: 'Bom tempo hoje, não é?' },
          { speaker: 'Coworker', text: 'Yes! Finally not so cold.', translation: 'Sim! Finalmente não tão frio.' },
          { speaker: 'You', text: 'Have you been busy lately?', translation: 'Você tem estado ocupado ultimamente?' },
          { speaker: 'Coworker', text: 'Very busy! And how about you?', translation: 'Muito ocupado! E você?' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'It is really hot today!', pt: 'Está muito quente hoje!' },
          { en: 'Did you watch the game last night?', pt: 'Você assistiu ao jogo ontem à noite?' },
          { en: 'I heard it is going to rain tomorrow.', pt: 'Ouvi dizer que vai chover amanhã.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Weather" significa:', options: ['Tempo/Clima', 'Água', 'Vento', 'Chuva'], correct: 0 },
      { id: 'q2', type: 'multiple-choice', question: '"How about you?" significa:', options: ['Como você?', 'E você?', 'Você como?', 'Que tal você?'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Busy" significa:', options: ['Ocupado', 'Livre', 'Ônibus', 'Negócio'], correct: 0 },
    ],
  },
  'wf-19': {
    id: 'wf-19',
    title: 'Apologizing & Excusing',
    titlePt: 'Pedindo Desculpas',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Pedindo Desculpas.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'I am sorry', pt: 'Desculpe', audio: true },
          { en: 'Excuse me', pt: 'Com licença', audio: true },
          { en: 'my mistake', pt: 'meu erro', audio: true },
          { en: 'forgive me', pt: 'me perdoe', audio: true },
          { en: 'I apologize', pt: 'Peço desculpas', audio: true },
          { en: 'no problem', pt: 'sem problema', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I am sorry, I am late.', translation: 'Desculpe, estou atrasado.' },
          { speaker: 'Supervisor', text: 'What happened?', translation: 'O que aconteceu?' },
          { speaker: 'You', text: 'The train was delayed. I apologize.', translation: 'O trem atrasou. Peço desculpas.' },
          { speaker: 'Supervisor', text: 'It is okay, just try to be on time next time.', translation: 'Tudo bem, apenas tente chegar no horário na próxima vez.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'Excuse me, may I pass?', pt: 'Com licença, posso passar?' },
          { en: 'I am sorry for the inconvenience.', pt: 'Desculpe pelo inconveniente.' },
          { en: 'It was my mistake, I will fix it.', pt: 'Foi meu erro, vou consertar.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"I am sorry" significa:', options: ['Tenho pena', 'Desculpe', 'Estou triste', 'Sinto falta'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"My mistake" significa:', options: ['Minha falta', 'Meu erro', 'Minha culpa', 'Minha confusão'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como responder a um pedido de desculpas?', options: ['OK', 'No problem', 'Whatever', 'Fine'], correct: 1 },
    ],
  },
  'wf-20': {
    id: 'wf-20',
    title: 'Expressing Gratitude',
    titlePt: 'Expressando Gratidão',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Expressando Gratidão.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'Thank you', pt: 'Obrigado', audio: true },
          { en: 'Thanks a lot', pt: 'Muito obrigado', audio: true },
          { en: 'I appreciate it', pt: 'Agradeço', audio: true },
          { en: 'You are welcome', pt: 'De nada', audio: true },
          { en: 'grateful', pt: 'grato', audio: true },
          { en: 'kind', pt: 'gentil', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Thank you so much for helping me!', translation: 'Muito obrigado por me ajudar!' },
          { speaker: 'Coworker', text: 'You are welcome! Anytime.', translation: 'De nada! Quando precisar.' },
          { speaker: 'You', text: 'I really appreciate it.', translation: 'Eu realmente agradeço.' },
          { speaker: 'Coworker', text: 'That is what coworkers are for!', translation: 'É para isso que servem os colegas!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'Thanks for teaching me.', pt: 'Obrigado por me ensinar.' },
          { en: 'I am grateful for your patience.', pt: 'Sou grato pela sua paciência.' },
          { en: 'That is very kind of you.', pt: 'Isso é muito gentil da sua parte.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"I appreciate it" significa:', options: ['Eu prezo isso', 'Eu agradeço', 'Eu preciso', 'Eu aceito'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"You are welcome" significa:', options: ['Você é bem-vindo', 'De nada', 'Você é aceito', 'Você é gentil'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Grateful" significa:', options: ['Cheio', 'Grande', 'Grato', 'Grátis'], correct: 2 },
    ],
  },
  'wf-21': {
    id: 'wf-21',
    title: 'Overtime & Schedule Changes',
    titlePt: 'Hora Extra e Mudanças de Horário',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Hora Extra e Mudanças de Horário.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'overtime', pt: 'hora extra', audio: true },
          { en: 'schedule change', pt: 'mudança de horário', audio: true },
          { en: 'available', pt: 'disponível', audio: true },
          { en: 'extra pay', pt: 'pagamento extra', audio: true },
          { en: 'shift swap', pt: 'troca de turno', audio: true },
          { en: 'cover for someone', pt: 'cobrir alguém', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Supervisor', text: 'Can you work overtime tomorrow?', translation: 'Você pode fazer hora extra amanhã?' },
          { speaker: 'You', text: 'How many hours?', translation: 'Quantas horas?' },
          { speaker: 'Supervisor', text: 'About 2 hours extra.', translation: 'Cerca de 2 horas a mais.' },
          { speaker: 'You', text: 'Yes, I am available.', translation: 'Sim, estou disponível.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'I cannot work overtime today.', pt: 'Não posso fazer hora extra hoje.' },
          { en: 'Is there extra pay for overtime?', pt: 'Tem pagamento extra por hora extra?' },
          { en: 'Can I swap shifts with someone?', pt: 'Posso trocar de turno com alguém?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Overtime" significa:', options: ['Fora do tempo', 'Hora extra', 'Além do tempo', 'Tempo livre'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Available" significa:', options: ['Aproveitável', 'Disponível', 'Avaliável', 'Aceitável'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: 'Como perguntar se pode fazer hora extra?', options: ['Overtime?', 'Can I work overtime?', 'Extra work?', 'More hours?'], correct: 1 },
    ],
  },
  'wf-22': {
    id: 'wf-22',
    title: 'Vacation Requests',
    titlePt: 'Pedindo Férias',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Pedindo Férias.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'vacation', pt: 'férias', audio: true },
          { en: 'day off', pt: 'dia de folga', audio: true },
          { en: 'request', pt: 'solicitar/pedido', audio: true },
          { en: 'approve', pt: 'aprovar', audio: true },
          { en: 'submit', pt: 'enviar/submeter', audio: true },
          { en: 'in advance', pt: 'com antecedência', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I would like to request a day off next Friday.', translation: 'Gostaria de pedir uma folga na próxima sexta.' },
          { speaker: 'Supervisor', text: 'Let me check the schedule.', translation: 'Deixe-me verificar a escala.' },
          { speaker: 'Supervisor', text: 'Yes, that should be fine. Please submit the request form.', translation: 'Sim, deve ser possível. Por favor, envie o formulário de solicitação.' },
          { speaker: 'You', text: 'Where can I get the form?', translation: 'Onde posso pegar o formulário?' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'I need to take 3 days off next month.', pt: 'Preciso tirar 3 dias de folga no próximo mês.' },
          { en: 'Please let me know if it is approved.', pt: 'Por favor, me avise se for aprovado.' },
          { en: 'I will submit the request today.', pt: 'Vou enviar o pedido hoje.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Day off" significa:', options: ['Dia fora', 'Dia de folga', 'Dia desligado', 'Dia afastado'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Request" significa:', options: ['Requentar', 'Solicitar', 'Requisitar', 'Requerer'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"In advance" significa:', options: ['Com antecedência', 'Em avanço', 'Adiantado', 'Antes'], correct: 0 },
    ],
  },
  'wf-23': {
    id: 'wf-23',
    title: 'Understanding Payslips',
    titlePt: 'Entendendo o Holerite',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Entendendo o Holerite.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'payslip', pt: 'holerite/contracheque', audio: true },
          { en: 'gross salary', pt: 'salário bruto', audio: true },
          { en: 'net salary', pt: 'salário líquido', audio: true },
          { en: 'deductions', pt: 'descontos', audio: true },
          { en: 'taxes', pt: 'impostos', audio: true },
          { en: 'bonus', pt: 'bônus', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'I do not understand this deduction.', translation: 'Não entendo este desconto.' },
          { speaker: 'HR', text: 'That is the income tax deduction.', translation: 'Esse é o desconto do imposto de renda.' },
          { speaker: 'You', text: 'And what is this amount here?', translation: 'E esse valor aqui?' },
          { speaker: 'HR', text: 'That is your overtime pay.', translation: 'Esse é seu pagamento de hora extra.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'When do we get paid?', pt: 'Quando recebemos o pagamento?' },
          { en: 'Is this my net or gross salary?', pt: 'Este é meu salário líquido ou bruto?' },
          { en: 'I think there is a mistake in my payslip.', pt: 'Acho que há um erro no meu holerite.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Payslip" significa:', options: ['Deslize de pagamento', 'Holerite', 'Recibo', 'Nota fiscal'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Net salary" significa:', options: ['Salário bruto', 'Salário líquido', 'Salário base', 'Salário total'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Deductions" significa:', options: ['Adições', 'Descontos', 'Deduções', 'Reduções'], correct: 1 },
    ],
  },
  'wf-24': {
    id: 'wf-24',
    title: 'Team Meetings',
    titlePt: 'Reuniões de Equipe',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Reuniões de Equipe.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'meeting', pt: 'reunião', audio: true },
          { en: 'agenda', pt: 'pauta', audio: true },
          { en: 'update', pt: 'atualização', audio: true },
          { en: 'discuss', pt: 'discutir', audio: true },
          { en: 'goal', pt: 'meta', audio: true },
          { en: 'announcement', pt: 'anúncio', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Supervisor', text: 'Good morning everyone. Let us start the meeting.', translation: 'Bom dia a todos. Vamos começar a reunião.' },
          { speaker: 'Supervisor', text: 'First, some announcements.', translation: 'Primeiro, alguns anúncios.' },
          { speaker: 'Supervisor', text: 'Our goal this month is to increase production by 10%.', translation: 'Nossa meta este mês é aumentar a produção em 10%.' },
          { speaker: 'You', text: 'How can we achieve that?', translation: 'Como podemos alcançar isso?' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'The meeting is at 9 AM.', pt: 'A reunião é às 9h.' },
          { en: 'What is on the agenda today?', pt: 'O que está na pauta hoje?' },
          { en: 'Do you have any updates?', pt: 'Você tem alguma atualização?' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Meeting" significa:', options: ['Encontrando', 'Reunião', 'Encontro', 'Medição'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Agenda" significa:', options: ['Caderno', 'Pauta', 'Calendário', 'Agenda'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Goal" significa:', options: ['Gol', 'Meta', 'Ouro', 'Objetivo'], correct: 1 },
    ],
  },
  'wf-25': {
    id: 'wf-25',
    title: 'Giving Feedback',
    titlePt: 'Dando Feedback',
    track: 'work-factory',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Nesta lição você vai aprender sobre: Dando Feedback.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário Essencial',
        words: [
          { en: 'feedback', pt: 'feedback/retorno', audio: true },
          { en: 'improvement', pt: 'melhoria', audio: true },
          { en: 'suggestion', pt: 'sugestão', audio: true },
          { en: 'performance', pt: 'desempenho', audio: true },
          { en: 'strength', pt: 'ponto forte', audio: true },
          { en: 'area to improve', pt: 'área a melhorar', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'Supervisor', text: 'I want to give you some feedback.', translation: 'Quero te dar um feedback.' },
          { speaker: 'Supervisor', text: 'Your work has been excellent lately.', translation: 'Seu trabalho tem sido excelente ultimamente.' },
          { speaker: 'You', text: 'Thank you! Is there anything I can improve?', translation: 'Obrigado! Há algo que posso melhorar?' },
          { speaker: 'Supervisor', text: 'Try to communicate more with your team.', translation: 'Tente se comunicar mais com sua equipe.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Pratique as frases aprendidas:',
        phrases: [
          { en: 'I have a suggestion to improve the process.', pt: 'Tenho uma sugestão para melhorar o processo.' },
          { en: 'Thank you for the feedback.', pt: 'Obrigado pelo feedback.' },
          { en: 'I will work on improving that area.', pt: 'Vou trabalhar para melhorar nessa área.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Improvement" significa:', options: ['Improviso', 'Melhoria', 'Movimento', 'Implementação'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Suggestion" significa:', options: ['Sugestão', 'Sucesso', 'Surpresa', 'Suspeita'], correct: 0 },
      { id: 'q3', type: 'multiple-choice', question: '"Performance" significa:', options: ['Perfume', 'Desempenho', 'Perfeição', 'Preferência'], correct: 1 },
    ],
  },


  'tl-1': {
    id: 'tl-1',
    title: 'Delivery Vocabulary',
    titlePt: 'Vocabulário de Entregas',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Como motorista de entregas, você precisa conhecer o vocabulário básico para fazer entregas e se comunicar com clientes e armazéns.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Entregas',
        words: [
          { en: 'delivery', pt: 'entrega', audio: true },
          { en: 'package', pt: 'pacote', audio: true },
          { en: 'signature', pt: 'assinatura', audio: true },
          { en: 'recipient', pt: 'destinatário', audio: true },
          { en: 'address', pt: 'endereço', audio: true },
          { en: 'tracking number', pt: 'número de rastreio', audio: true },
          { en: 'fragile', pt: 'frágil', audio: true },
          { en: 'urgent', pt: 'urgente', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Good morning. I have a delivery for you.', translation: 'Bom dia. Tenho uma entrega para você.' },
          { speaker: 'Customer', text: 'What is it?', translation: 'O que é?' },
          { speaker: 'You', text: 'It\'s a package from Amazon.', translation: 'É um pacote da Amazon.' },
          { speaker: 'Customer', text: 'Do I need to sign?', translation: 'Preciso assinar?' },
          { speaker: 'You', text: 'Yes, please sign here.', translation: 'Sim, por favor assine aqui.' },
          { speaker: 'Customer', text: 'Thank you!', translation: 'Obrigado!' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases úteis para entregas:',
        phrases: [
          { en: 'Please sign here.', pt: 'Por favor, assine aqui.' },
          { en: 'This package is fragile.', pt: 'Este pacote é frágil.' },
          { en: 'Is this the correct address?', pt: 'Este é o endereço correto?' },
          { en: 'The delivery is complete.', pt: 'A entrega está completa.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Delivery" significa:', options: ['Compra', 'Entrega', 'Pagamento', 'Devolução'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como se diz "assinatura" em inglês?', options: ['Signal', 'Sign', 'Signature', 'Stamp'], correct: 2 },
      { id: 'q3', type: 'multiple-choice', question: '"Fragile" significa:', options: ['Pesado', 'Leve', 'Frágil', 'Grande'], correct: 2 },
      { id: 'q4', type: 'multiple-choice', question: '"Please sign here" significa:', options: ['Por favor, sente aqui', 'Por favor, assine aqui', 'Por favor, espere aqui', 'Por favor, ligue aqui'], correct: 1 },
    ],
  },

  // Business - Business Greetings
  'bs-1': {
    id: 'bs-1',
    title: 'Business Greetings',
    titlePt: 'Cumprimentos de Negócios',
    track: 'business',
    duration: 5,
    xp: 50,
    sections: [
      {
        type: 'intro',
        title: 'Situação',
        content: 'Em ambientes de negócios, os cumprimentos são mais formais. Vamos aprender as expressões profissionais usadas em reuniões e encontros de trabalho.',
      },
      {
        type: 'vocabulary',
        title: 'Vocabulário de Negócios',
        words: [
          { en: 'It\'s a pleasure to meet you', pt: 'É um prazer conhecê-lo', audio: true },
          { en: 'How do you do?', pt: 'Como vai? (formal)', audio: true },
          { en: 'Please have a seat', pt: 'Por favor, sente-se', audio: true },
          { en: 'Thank you for your time', pt: 'Obrigado pelo seu tempo', audio: true },
          { en: 'I look forward to working with you', pt: 'Aguardo trabalhar com você', audio: true },
          { en: 'Let me introduce myself', pt: 'Deixe-me me apresentar', audio: true },
        ],
      },
      {
        type: 'dialog',
        title: 'Diálogo',
        conversation: [
          { speaker: 'You', text: 'Good morning. I\'m Carlos Silva from ABC Company.', translation: 'Bom dia. Sou Carlos Silva da empresa ABC.' },
          { speaker: 'Client', text: 'It\'s a pleasure to meet you, Mr. Silva.', translation: 'É um prazer conhecê-lo, Sr. Silva.' },
          { speaker: 'You', text: 'The pleasure is mine. Thank you for meeting with me.', translation: 'O prazer é meu. Obrigado por se reunir comigo.' },
          { speaker: 'Client', text: 'Please have a seat. Would you like some coffee?', translation: 'Por favor, sente-se. Gostaria de um café?' },
          { speaker: 'You', text: 'Yes, please. That would be great.', translation: 'Sim, por favor. Seria ótimo.' },
        ],
      },
      {
        type: 'practice',
        title: 'Pratique',
        instruction: 'Frases formais de negócios:',
        phrases: [
          { en: 'I appreciate your time.', pt: 'Agradeço o seu tempo.' },
          { en: 'Looking forward to our meeting.', pt: 'Aguardo nossa reunião.' },
          { en: 'It was nice meeting you.', pt: 'Foi bom conhecê-lo.' },
        ],
      },
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"It\'s a pleasure to meet you" é usado em contextos:', options: ['Informais', 'Formais/Profissionais', 'Apenas com amigos', 'Apenas em festas'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como agradecer pelo tempo de alguém formalmente?', options: ['Thanks a lot!', 'Thank you for your time', 'Cheers!', 'No problem'], correct: 1 },
      { id: 'q3', type: 'multiple-choice', question: '"Please have a seat" significa:', options: ['Por favor, fique de pé', 'Por favor, sente-se', 'Por favor, saia', 'Por favor, espere'], correct: 1 },
      { id: 'q4', type: 'multiple-choice', question: '"Looking forward to" significa:', options: ['Olhando para frente', 'Aguardando ansiosamente', 'Lembrando de', 'Esquecendo de'], correct: 1 },
    ],
  },

  // ==========================================
  // TRUCK & LOGISTICS - ALL LESSONS (tl-2 to tl-25)
  // ==========================================
  'tl-2': {
    id: 'tl-2',
    title: 'Types of Packages',
    titlePt: 'Tipos de Pacotes',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a identificar e descrever diferentes tipos de pacotes e embalagens.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'box', pt: 'caixa', audio: true },
        { en: 'envelope', pt: 'envelope', audio: true },
        { en: 'pallet', pt: 'palete', audio: true },
        { en: 'fragile', pt: 'frágil', audio: true },
        { en: 'heavy package', pt: 'pacote pesado', audio: true },
        { en: 'small parcel', pt: 'pacote pequeno', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Dispatcher', text: 'You have 3 types of packages today.', translation: 'Você tem 3 tipos de pacotes hoje.' },
        { speaker: 'You', text: 'What sizes are they?', translation: 'Quais são os tamanhos?' },
        { speaker: 'Dispatcher', text: 'Two large boxes and several small parcels.', translation: 'Duas caixas grandes e vários pacotes pequenos.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'This package is marked as fragile.', pt: 'Este pacote está marcado como frágil.' },
        { en: 'The pallet needs to be secured.', pt: 'O palete precisa ser preso.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Fragile" significa:', options: ['Forte', 'Frágil', 'Pesado', 'Grande'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Pallet" significa:', options: ['Paleta', 'Palete', 'Paladar', 'Palito'], correct: 1 },
    ],
  },
  'tl-3': {
    id: 'tl-3',
    title: 'Loading & Unloading',
    titlePt: 'Carga e Descarga',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda o vocabulário para carregar e descarregar mercadorias.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'load', pt: 'carregar', audio: true },
        { en: 'unload', pt: 'descarregar', audio: true },
        { en: 'forklift', pt: 'empilhadeira', audio: true },
        { en: 'dock', pt: 'doca', audio: true },
        { en: 'ramp', pt: 'rampa', audio: true },
        { en: 'secure', pt: 'prender', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Where should I load the truck?', translation: 'Onde devo carregar o caminhão?' },
        { speaker: 'Worker', text: 'At dock number 5.', translation: 'Na doca número 5.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Please help me unload these boxes.', pt: 'Por favor, me ajude a descarregar estas caixas.' },
        { en: 'Make sure everything is secure.', pt: 'Certifique-se de que tudo está preso.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Load" significa:', options: ['Lodo', 'Carregar', 'Soltar', 'Carimbar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Forklift" significa:', options: ['Garfo', 'Empilhadeira', 'Elevador', 'Guindaste'], correct: 1 },
    ],
  },
  'tl-4': {
    id: 'tl-4',
    title: 'Delivery Confirmation',
    titlePt: 'Confirmação de Entrega',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a confirmar entregas com clientes.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'signature', pt: 'assinatura', audio: true },
        { en: 'sign here', pt: 'assine aqui', audio: true },
        { en: 'delivery note', pt: 'nota de entrega', audio: true },
        { en: 'receipt', pt: 'recibo', audio: true },
        { en: 'confirm', pt: 'confirmar', audio: true },
        { en: 'delivered', pt: 'entregue', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Good morning. I have a delivery for you.', translation: 'Bom dia. Tenho uma entrega para você.' },
        { speaker: 'Customer', text: 'Please sign here to confirm delivery.', translation: 'Por favor, assine aqui para confirmar a entrega.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I need your signature, please.', pt: 'Preciso da sua assinatura, por favor.' },
        { en: 'Here is your copy of the receipt.', pt: 'Aqui está sua cópia do recibo.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Signature" significa:', options: ['Sinal', 'Assinatura', 'Selo', 'Símbolo'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Delivered" significa:', options: ['Delicado', 'Entregue', 'Libertado', 'Devolvido'], correct: 1 },
    ],
  },
  'tl-5': {
    id: 'tl-5',
    title: 'Customer Interactions',
    titlePt: 'Interação com Clientes',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a se comunicar com clientes durante entregas.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'customer', pt: 'cliente', audio: true },
        { en: 'address', pt: 'endereço', audio: true },
        { en: 'correct address', pt: 'endereço correto', audio: true },
        { en: 'wrong delivery', pt: 'entrega errada', audio: true },
        { en: 'complaint', pt: 'reclamação', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Hello, is this the correct address?', translation: 'Olá, este é o endereço correto?' },
        { speaker: 'Customer', text: 'Yes, that is right.', translation: 'Sim, está certo.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Thank you for waiting.', pt: 'Obrigado por esperar.' },
        { en: 'Have a nice day!', pt: 'Tenha um bom dia!' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Customer" significa:', options: ['Costume', 'Cliente', 'Costumeiro', 'Customizado'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Address" significa:', options: ['Adicionar', 'Endereço', 'Adornar', 'Adversário'], correct: 1 },
    ],
  },
  'tl-6': {
    id: 'tl-6',
    title: 'GPS & Directions',
    titlePt: 'GPS e Direções',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a usar GPS e entender direções em inglês.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'GPS', pt: 'GPS', audio: true },
        { en: 'turn left', pt: 'vire à esquerda', audio: true },
        { en: 'turn right', pt: 'vire à direita', audio: true },
        { en: 'straight ahead', pt: 'em frente', audio: true },
        { en: 'destination', pt: 'destino', audio: true },
        { en: 'route', pt: 'rota', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'GPS', text: 'In 200 meters, turn right.', translation: 'Em 200 metros, vire à direita.' },
        { speaker: 'GPS', text: 'You have arrived at your destination.', translation: 'Você chegou ao seu destino.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Recalculating route...', pt: 'Recalculando rota...' },
        { en: 'The destination is on your left.', pt: 'O destino está à sua esquerda.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Turn left" significa:', options: ['Vire à direita', 'Vire à esquerda', 'Siga em frente', 'Volte'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Destination" significa:', options: ['Destinatário', 'Destino', 'Distância', 'Distinção'], correct: 1 },
    ],
  },
  'tl-7': {
    id: 'tl-7',
    title: 'Reading Addresses',
    titlePt: 'Lendo Endereços',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a ler e entender endereços em inglês.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'street', pt: 'rua', audio: true },
        { en: 'avenue', pt: 'avenida', audio: true },
        { en: 'building', pt: 'prédio', audio: true },
        { en: 'floor', pt: 'andar', audio: true },
        { en: 'apartment', pt: 'apartamento', audio: true },
        { en: 'zip code', pt: 'CEP', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'I am looking for 123 Main Street.', translation: 'Estou procurando Rua Principal 123.' },
        { speaker: 'Person', text: 'Third floor, apartment 305.', translation: 'Terceiro andar, apartamento 305.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'What is the zip code for this area?', pt: 'Qual é o CEP desta área?' },
        { en: 'Is this building number 50?', pt: 'Este é o prédio número 50?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Street" significa:', options: ['Estreito', 'Rua', 'Estrada', 'Estância'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Floor" significa:', options: ['Flor', 'Andar', 'Forro', 'Fluor'], correct: 1 },
    ],
  },
  'tl-8': {
    id: 'tl-8',
    title: 'Asking for Directions',
    titlePt: 'Pedindo Direções',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a pedir e entender direções.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'excuse me', pt: 'com licença', audio: true },
        { en: 'how do I get to...?', pt: 'como chego a...?', audio: true },
        { en: 'is it far?', pt: 'é longe?', audio: true },
        { en: 'nearby', pt: 'perto', audio: true },
        { en: 'landmark', pt: 'ponto de referência', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Excuse me, how do I get to the warehouse?', translation: 'Com licença, como chego ao armazém?' },
        { speaker: 'Person', text: 'Go straight for 2 blocks, then turn left.', translation: 'Siga em frente por 2 quarteirões, depois vire à esquerda.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Is there a landmark nearby?', pt: 'Há algum ponto de referência perto?' },
        { en: 'I am lost. Can you help me?', pt: 'Estou perdido. Pode me ajudar?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"How do I get to...?" significa:', options: ['Onde fico...?', 'Como chego a...?', 'Quando vou para...?', 'Por que ir para...?'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Nearby" significa:', options: ['Longe', 'Perto', 'Atrás', 'Embaixo'], correct: 1 },
    ],
  },
  'tl-9': {
    id: 'tl-9',
    title: 'Traffic Vocabulary',
    titlePt: 'Vocabulário de Trânsito',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário relacionado ao trânsito.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'traffic', pt: 'trânsito', audio: true },
        { en: 'traffic jam', pt: 'engarrafamento', audio: true },
        { en: 'highway', pt: 'rodovia', audio: true },
        { en: 'speed limit', pt: 'limite de velocidade', audio: true },
        { en: 'lane', pt: 'faixa', audio: true },
        { en: 'accident', pt: 'acidente', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'There is a lot of traffic today.', translation: 'Tem muito trânsito hoje.' },
        { speaker: 'Dispatcher', text: 'Yes, there is an accident on the highway.', translation: 'Sim, há um acidente na rodovia.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I am stuck in a traffic jam.', pt: 'Estou preso no engarrafamento.' },
        { en: 'What is the speed limit here?', pt: 'Qual é o limite de velocidade aqui?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Traffic jam" significa:', options: ['Geleia de tráfego', 'Engarrafamento', 'Fluxo de tráfego', 'Trânsito livre'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Speed limit" significa:', options: ['Velocidade máxima', 'Limite de velocidade', 'Velocidade mínima', 'Velocidade média'], correct: 1 },
    ],
  },
  'tl-10': {
    id: 'tl-10',
    title: 'Road Signs',
    titlePt: 'Placas de Trânsito',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a entender placas de trânsito em inglês.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'stop sign', pt: 'placa de pare', audio: true },
        { en: 'yield', pt: 'dê a preferência', audio: true },
        { en: 'no parking', pt: 'proibido estacionar', audio: true },
        { en: 'one way', pt: 'mão única', audio: true },
        { en: 'speed bump', pt: 'lombada', audio: true },
        { en: 'detour', pt: 'desvio', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'What does that sign mean?', translation: 'O que aquela placa significa?' },
        { speaker: 'Coworker', text: 'It means no parking in this area.', translation: 'Significa proibido estacionar nesta área.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Slow down, there is a speed bump.', pt: 'Diminua a velocidade, há uma lombada.' },
        { en: 'This is a one way street.', pt: 'Esta é uma rua de mão única.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"No parking" significa:', options: ['Não estacione', 'Proibido estacionar', 'Estacionamento proibido', 'Todas as anteriores'], correct: 3 },
      { id: 'q2', type: 'multiple-choice', question: '"Detour" significa:', options: ['Retorno', 'Desvio', 'Atalho', 'Contorno'], correct: 1 },
    ],
  },
  'tl-11': {
    id: 'tl-11',
    title: 'Warehouse Communication',
    titlePt: 'Comunicação no Armazém',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a se comunicar em armazéns e depósitos.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'warehouse', pt: 'armazém', audio: true },
        { en: 'inventory', pt: 'inventário', audio: true },
        { en: 'shelf', pt: 'prateleira', audio: true },
        { en: 'aisle', pt: 'corredor', audio: true },
        { en: 'storage', pt: 'armazenamento', audio: true },
        { en: 'shipment', pt: 'remessa', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Where can I find these items?', translation: 'Onde posso encontrar esses itens?' },
        { speaker: 'Worker', text: 'They are in aisle 4, shelf B.', translation: 'Estão no corredor 4, prateleira B.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'The warehouse is full today.', pt: 'O armazém está cheio hoje.' },
        { en: 'Check the inventory list.', pt: 'Verifique a lista de inventário.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Warehouse" significa:', options: ['Casa', 'Armazém', 'Loja', 'Depósito'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Shelf" significa:', options: ['Concha', 'Prateleira', 'Abrigo', 'Casca'], correct: 1 },
    ],
  },
  'tl-12': {
    id: 'tl-12',
    title: 'Forklift Operations',
    titlePt: 'Operação de Empilhadeira',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário para operação de empilhadeira.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'forklift', pt: 'empilhadeira', audio: true },
        { en: 'lift', pt: 'levantar', audio: true },
        { en: 'lower', pt: 'abaixar', audio: true },
        { en: 'stack', pt: 'empilhar', audio: true },
        { en: 'capacity', pt: 'capacidade', audio: true },
        { en: 'horn', pt: 'buzina', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Supervisor', text: 'Do you have a forklift license?', translation: 'Você tem licença de empilhadeira?' },
        { speaker: 'You', text: 'Yes, I have 2 years of experience.', translation: 'Sim, tenho 2 anos de experiência.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Do not exceed the weight capacity.', pt: 'Não exceda a capacidade de peso.' },
        { en: 'Use the horn when turning corners.', pt: 'Use a buzina ao virar esquinas.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Lift" significa:', options: ['Elevador', 'Levantar', 'Deixar', 'Vida'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Stack" significa:', options: ['Atacar', 'Empilhar', 'Prender', 'Esticar'], correct: 1 },
    ],
  },
  'tl-13': {
    id: 'tl-13',
    title: 'Inventory Terms',
    titlePt: 'Termos de Inventário',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda termos de controle de inventário.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'inventory', pt: 'inventário', audio: true },
        { en: 'stock', pt: 'estoque', audio: true },
        { en: 'count', pt: 'contar', audio: true },
        { en: 'missing', pt: 'faltando', audio: true },
        { en: 'surplus', pt: 'excedente', audio: true },
        { en: 'barcode', pt: 'código de barras', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'I need to count the inventory.', translation: 'Preciso contar o inventário.' },
        { speaker: 'Coworker', text: 'Use the barcode scanner.', translation: 'Use o leitor de código de barras.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'We are low on stock.', pt: 'Estamos com estoque baixo.' },
        { en: 'Scan the barcode to check the item.', pt: 'Escaneie o código de barras para verificar o item.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Stock" significa:', options: ['Estoque', 'Estaca', 'Estocar', 'Estocagem'], correct: 0 },
      { id: 'q2', type: 'multiple-choice', question: '"Missing" significa:', options: ['Missão', 'Faltando', 'Perdendo', 'Errando'], correct: 1 },
    ],
  },
  'tl-14': {
    id: 'tl-14',
    title: 'Shipping Documents',
    titlePt: 'Documentos de Envio',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda sobre documentos de transporte e envio.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'bill of lading', pt: 'conhecimento de embarque', audio: true },
        { en: 'invoice', pt: 'nota fiscal', audio: true },
        { en: 'packing list', pt: 'lista de embalagem', audio: true },
        { en: 'tracking number', pt: 'número de rastreio', audio: true },
        { en: 'proof of delivery', pt: 'comprovante de entrega', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Customer', text: 'Do you have the invoice?', translation: 'Você tem a nota fiscal?' },
        { speaker: 'You', text: 'Yes, here it is with the packing list.', translation: 'Sim, aqui está com a lista de embalagem.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Please sign the proof of delivery.', pt: 'Por favor, assine o comprovante de entrega.' },
        { en: 'What is the tracking number?', pt: 'Qual é o número de rastreio?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Invoice" significa:', options: ['Voz', 'Nota fiscal', 'Envelope', 'Entrada'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Tracking number" significa:', options: ['Número de trilha', 'Número de rastreio', 'Número de tração', 'Número de tráfego'], correct: 1 },
    ],
  },
  'tl-15': {
    id: 'tl-15',
    title: 'Reporting Damaged Goods',
    titlePt: 'Reportando Produtos Danificados',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a reportar produtos danificados.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'damaged', pt: 'danificado', audio: true },
        { en: 'broken', pt: 'quebrado', audio: true },
        { en: 'dent', pt: 'amassado', audio: true },
        { en: 'scratch', pt: 'arranhão', audio: true },
        { en: 'claim', pt: 'reclamação', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'This package was damaged during shipping.', translation: 'Este pacote foi danificado durante o envio.' },
        { speaker: 'Supervisor', text: 'Take photos for documentation.', translation: 'Tire fotos para documentação.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'There is a big dent in this box.', pt: 'Há um grande amassado nesta caixa.' },
        { en: 'The product has some scratches.', pt: 'O produto tem alguns arranhões.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Damaged" significa:', options: ['Damnado', 'Danificado', 'Domado', 'Diminuído'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Dent" significa:', options: ['Dente', 'Amassado', 'Dentro', 'Dentista'], correct: 1 },
    ],
  },
  'tl-16': {
    id: 'tl-16',
    title: 'Delivery Problems',
    titlePt: 'Problemas de Entrega',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a lidar com problemas de entrega.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'delay', pt: 'atraso', audio: true },
        { en: 'wrong address', pt: 'endereço errado', audio: true },
        { en: 'not home', pt: 'não está em casa', audio: true },
        { en: 'reschedule', pt: 'reagendar', audio: true },
        { en: 'return to sender', pt: 'devolver ao remetente', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'No one is home at this address.', translation: 'Não há ninguém em casa neste endereço.' },
        { speaker: 'Dispatcher', text: 'Try calling the customer.', translation: 'Tente ligar para o cliente.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I am sorry, there is a delay with your delivery.', pt: 'Desculpe, há um atraso com sua entrega.' },
        { en: 'Would you like to reschedule?', pt: 'Você gostaria de reagendar?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Delay" significa:', options: ['Dia', 'Atraso', 'Deleite', 'Delegar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Reschedule" significa:', options: ['Reescalar', 'Reagendar', 'Redescobrir', 'Reestruturar'], correct: 1 },
    ],
  },
  'tl-17': {
    id: 'tl-17',
    title: 'Vehicle Issues',
    titlePt: 'Problemas com Veículo',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a reportar problemas com o veículo.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'flat tire', pt: 'pneu furado', audio: true },
        { en: 'engine problem', pt: 'problema no motor', audio: true },
        { en: 'brakes', pt: 'freios', audio: true },
        { en: 'fuel', pt: 'combustível', audio: true },
        { en: 'breakdown', pt: 'pane', audio: true },
        { en: 'mechanic', pt: 'mecânico', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'I have a flat tire.', translation: 'Estou com um pneu furado.' },
        { speaker: 'Dispatcher', text: 'Can you change it yourself?', translation: 'Você consegue trocar sozinho?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'The engine is making a strange noise.', pt: 'O motor está fazendo um barulho estranho.' },
        { en: 'I need to refuel the truck.', pt: 'Preciso abastecer o caminhão.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Flat tire" significa:', options: ['Pneu liso', 'Pneu furado', 'Pneu cheio', 'Pneu novo'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Breakdown" significa:', options: ['Quebrar', 'Pane', 'Descanso', 'Desmaio'], correct: 1 },
    ],
  },
  'tl-18': {
    id: 'tl-18',
    title: 'Calling for Support',
    titlePt: 'Ligando para Suporte',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a pedir ajuda por telefone.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'call', pt: 'ligar', audio: true },
        { en: 'emergency', pt: 'emergência', audio: true },
        { en: 'support', pt: 'suporte', audio: true },
        { en: 'location', pt: 'localização', audio: true },
        { en: 'assistance', pt: 'assistência', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Hello, I need assistance.', translation: 'Olá, preciso de assistência.' },
        { speaker: 'Support', text: 'What is your location?', translation: 'Qual é sua localização?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I need emergency assistance.', pt: 'Preciso de assistência de emergência.' },
        { en: 'Can you send a mechanic?', pt: 'Você pode enviar um mecânico?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Location" significa:', options: ['Locação', 'Localização', 'Locomoção', 'Local'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Assistance" significa:', options: ['Assistência', 'Assistente', 'Auxílio', 'Ajuda'], correct: 0 },
    ],
  },
  'tl-19': {
    id: 'tl-19',
    title: 'Accident Reports',
    titlePt: 'Relatórios de Acidente',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a reportar acidentes de trânsito.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'accident', pt: 'acidente', audio: true },
        { en: 'report', pt: 'relatório', audio: true },
        { en: 'witness', pt: 'testemunha', audio: true },
        { en: 'insurance', pt: 'seguro', audio: true },
        { en: 'police', pt: 'polícia', audio: true },
        { en: 'damage', pt: 'dano', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'I need to report an accident.', translation: 'Preciso reportar um acidente.' },
        { speaker: 'Supervisor', text: 'Is anyone hurt?', translation: 'Alguém está machucado?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I was involved in a minor accident.', pt: 'Eu me envolvi em um acidente pequeno.' },
        { en: 'Do I need to call the police?', pt: 'Preciso chamar a polícia?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Report" significa:', options: ['Reportagem', 'Relatório', 'Reporte', 'Reportar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Witness" significa:', options: ['Teste', 'Testemunha', 'Vítima', 'Voluntário'], correct: 1 },
    ],
  },
  'tl-20': {
    id: 'tl-20',
    title: 'Gas Station Conversations',
    titlePt: 'Conversas no Posto',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a se comunicar em postos de combustível.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'gas station', pt: 'posto de gasolina', audio: true },
        { en: 'fill up', pt: 'encher o tanque', audio: true },
        { en: 'diesel', pt: 'diesel', audio: true },
        { en: 'gasoline', pt: 'gasolina', audio: true },
        { en: 'pump', pt: 'bomba', audio: true },
        { en: 'receipt', pt: 'recibo', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'I need to fill up with diesel, please.', translation: 'Preciso encher com diesel, por favor.' },
        { speaker: 'Attendant', text: 'Full tank?', translation: 'Tanque cheio?' },
        { speaker: 'You', text: 'Yes, please. And I need a receipt.', translation: 'Sim, por favor. E preciso de um recibo.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Where is the nearest gas station?', pt: 'Onde é o posto de gasolina mais próximo?' },
        { en: 'Which pump should I use?', pt: 'Qual bomba devo usar?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Fill up" significa:', options: ['Preencher', 'Encher o tanque', 'Completar', 'Abastecer'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Pump" significa:', options: ['Pompa', 'Bomba', 'Pulso', 'Punho'], correct: 1 },
    ],
  },
  'tl-21': {
    id: 'tl-21',
    title: 'Route Planning',
    titlePt: 'Planejamento de Rotas',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a planejar rotas de entrega.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'route', pt: 'rota', audio: true },
        { en: 'plan', pt: 'planejar', audio: true },
        { en: 'shortcut', pt: 'atalho', audio: true },
        { en: 'distance', pt: 'distância', audio: true },
        { en: 'estimated time', pt: 'tempo estimado', audio: true },
        { en: 'stops', pt: 'paradas', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Dispatcher', text: 'Today you have 10 stops.', translation: 'Hoje você tem 10 paradas.' },
        { speaker: 'You', text: 'What is the best route?', translation: 'Qual é a melhor rota?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Is there a shortcut to this location?', pt: 'Há um atalho para este local?' },
        { en: 'What is the total distance today?', pt: 'Qual é a distância total hoje?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Shortcut" significa:', options: ['Corte curto', 'Atalho', 'Curta distância', 'Caminho rápido'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Estimated time" significa:', options: ['Tempo exato', 'Tempo estimado', 'Tempo final', 'Tempo inicial'], correct: 1 },
    ],
  },
  'tl-22': {
    id: 'tl-22',
    title: 'Time Management',
    titlePt: 'Gestão de Tempo',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário de gestão de tempo.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'on time', pt: 'no horário', audio: true },
        { en: 'late', pt: 'atrasado', audio: true },
        { en: 'early', pt: 'adiantado', audio: true },
        { en: 'deadline', pt: 'prazo', audio: true },
        { en: 'schedule', pt: 'cronograma', audio: true },
        { en: 'priority', pt: 'prioridade', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Supervisor', text: 'This delivery is a priority.', translation: 'Esta entrega é prioridade.' },
        { speaker: 'You', text: 'What is the deadline?', translation: 'Qual é o prazo?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I am running late today.', pt: 'Estou atrasado hoje.' },
        { en: 'Let me check my schedule.', pt: 'Deixe-me verificar meu cronograma.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"On time" significa:', options: ['No tempo', 'No horário', 'A tempo', 'Com tempo'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Deadline" significa:', options: ['Linha morta', 'Prazo', 'Data limite', 'Final'], correct: 1 },
    ],
  },
  'tl-23': {
    id: 'tl-23',
    title: 'Customs & Border',
    titlePt: 'Alfândega e Fronteira',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário de alfândega e fronteira.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'customs', pt: 'alfândega', audio: true },
        { en: 'border', pt: 'fronteira', audio: true },
        { en: 'declaration', pt: 'declaração', audio: true },
        { en: 'inspection', pt: 'inspeção', audio: true },
        { en: 'documents', pt: 'documentos', audio: true },
        { en: 'duty', pt: 'imposto', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Officer', text: 'May I see your documents?', translation: 'Posso ver seus documentos?' },
        { speaker: 'You', text: 'Here are my license and delivery papers.', translation: 'Aqui estão minha licença e documentos de entrega.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I have nothing to declare.', pt: 'Não tenho nada a declarar.' },
        { en: 'All my documents are in order.', pt: 'Todos os meus documentos estão em ordem.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Customs" significa:', options: ['Costumes', 'Alfândega', 'Clientes', 'Acostumados'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Declaration" significa:', options: ['Declamação', 'Declaração', 'Decoração', 'Decisão'], correct: 1 },
    ],
  },
  'tl-24': {
    id: 'tl-24',
    title: 'Long Haul Vocabulary',
    titlePt: 'Vocabulário de Longa Distância',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário para viagens de longa distância.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'long haul', pt: 'longa distância', audio: true },
        { en: 'rest stop', pt: 'parada de descanso', audio: true },
        { en: 'truck stop', pt: 'posto de caminhão', audio: true },
        { en: 'sleeper cab', pt: 'cabine com cama', audio: true },
        { en: 'driving hours', pt: 'horas de direção', audio: true },
        { en: 'overnight', pt: 'pernoite', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'How many driving hours are left?', translation: 'Quantas horas de direção restam?' },
        { speaker: 'Dispatcher', text: 'You can drive 4 more hours today.', translation: 'Você pode dirigir mais 4 horas hoje.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I need to take a rest break.', pt: 'Preciso fazer uma pausa para descanso.' },
        { en: 'I will stay overnight here.', pt: 'Vou pernoitar aqui.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Long haul" significa:', options: ['Longo salão', 'Longa distância', 'Puxar longe', 'Longe de casa'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Rest stop" significa:', options: ['Parada restante', 'Parada de descanso', 'Ponto de descanso', 'Área de descanso'], correct: 1 },
    ],
  },
  'tl-25': {
    id: 'tl-25',
    title: 'Radio Communication',
    titlePt: 'Comunicação por Rádio',
    track: 'truck-logistics',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda comunicação profissional por rádio.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'copy that', pt: 'entendido', audio: true },
        { en: 'over', pt: 'câmbio', audio: true },
        { en: 'roger', pt: 'afirmativo', audio: true },
        { en: 'base', pt: 'base', audio: true },
        { en: 'ten-four', pt: 'ok/entendido', audio: true },
        { en: 'come in', pt: 'responda', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Base', text: 'Truck 42, come in. Over.', translation: 'Caminhão 42, responda. Câmbio.' },
        { speaker: 'You', text: 'This is Truck 42. Go ahead. Over.', translation: 'Aqui é o Caminhão 42. Prossiga. Câmbio.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Copy that. I am on my way.', pt: 'Entendido. Estou a caminho.' },
        { en: 'Ten-four. Message received.', pt: 'Ok. Mensagem recebida.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Copy that" significa:', options: ['Copie isso', 'Entendido', 'Copiar', 'Copiado'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Over" no rádio significa:', options: ['Acabou', 'Câmbio', 'Sobre', 'Em cima'], correct: 1 },
    ],
  },

  // ==========================================
  // BUSINESS ENGLISH - ALL LESSONS (bs-2 to bs-25)
  // ==========================================
  'bs-2': {
    id: 'bs-2',
    title: 'Email Basics',
    titlePt: 'Básico de E-mail',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a escrever e-mails profissionais em inglês.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'subject', pt: 'assunto', audio: true },
        { en: 'attachment', pt: 'anexo', audio: true },
        { en: 'forward', pt: 'encaminhar', audio: true },
        { en: 'reply', pt: 'responder', audio: true },
        { en: 'regards', pt: 'atenciosamente', audio: true },
      ]},
      { type: 'dialog', title: 'Exemplo de E-mail', conversation: [
        { speaker: 'Subject', text: 'Meeting Request - Project Update', translation: 'Solicitação de Reunião - Atualização do Projeto' },
        { speaker: 'Body', text: 'Dear Mr. Tanaka, I hope this email finds you well.', translation: 'Prezado Sr. Tanaka, espero que este e-mail o encontre bem.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Please find attached the document.', pt: 'Por favor, encontre o documento em anexo.' },
        { en: 'I look forward to hearing from you.', pt: 'Aguardo sua resposta.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Attachment" significa:', options: ['Ataque', 'Anexo', 'Atenção', 'Atacante'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Best regards" significa:', options: ['Melhores olhares', 'Atenciosamente', 'Bons desejos', 'Melhores cumprimentos'], correct: 1 },
    ],
  },
  'bs-3': {
    id: 'bs-3',
    title: 'Phone Etiquette',
    titlePt: 'Etiqueta Telefônica',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a fazer e receber ligações profissionais.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'hold the line', pt: 'aguarde na linha', audio: true },
        { en: 'transfer', pt: 'transferir', audio: true },
        { en: 'extension', pt: 'ramal', audio: true },
        { en: 'voicemail', pt: 'correio de voz', audio: true },
        { en: 'call back', pt: 'retornar a ligação', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Good morning, ABC Company. How may I help you?', translation: 'Bom dia, Empresa ABC. Como posso ajudá-lo?' },
        { speaker: 'You', text: 'One moment, please. I will transfer your call.', translation: 'Um momento, por favor. Vou transferir sua ligação.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Could you please hold?', pt: 'Você poderia aguardar, por favor?' },
        { en: 'I will call you back later.', pt: 'Vou retornar sua ligação depois.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Hold the line" significa:', options: ['Segure a linha', 'Aguarde na linha', 'Pegue a linha', 'Solte a linha'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Extension" significa:', options: ['Extensão', 'Ramal', 'Prolongar', 'Estender'], correct: 1 },
    ],
  },
  'bs-4': {
    id: 'bs-4',
    title: 'Meeting Vocabulary',
    titlePt: 'Vocabulário de Reuniões',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário essencial para reuniões.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'agenda', pt: 'pauta', audio: true },
        { en: 'minutes', pt: 'ata', audio: true },
        { en: 'action items', pt: 'itens de ação', audio: true },
        { en: 'follow up', pt: 'acompanhamento', audio: true },
        { en: 'deadline', pt: 'prazo', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Manager', text: 'Let us begin. Here is today agenda.', translation: 'Vamos começar. Aqui está a pauta de hoje.' },
        { speaker: 'You', text: 'Should I take the minutes?', translation: 'Devo fazer a ata?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'What is the deadline for this project?', pt: 'Qual é o prazo para este projeto?' },
        { en: 'I will follow up on this next week.', pt: 'Vou fazer o acompanhamento disso na próxima semana.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Minutes" em reuniões significa:', options: ['Minutos', 'Ata', 'Tempo', 'Detalhes'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Follow up" significa:', options: ['Seguir acima', 'Acompanhamento', 'Seguir depois', 'Perseguir'], correct: 1 },
    ],
  },
  'bs-5': {
    id: 'bs-5',
    title: 'Presentations',
    titlePt: 'Apresentações',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a fazer apresentações em inglês.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'slide', pt: 'slide', audio: true },
        { en: 'chart', pt: 'gráfico', audio: true },
        { en: 'data', pt: 'dados', audio: true },
        { en: 'conclusion', pt: 'conclusão', audio: true },
        { en: 'questions', pt: 'perguntas', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Good morning everyone. Today I will present our quarterly results.', translation: 'Bom dia a todos. Hoje vou apresentar nossos resultados trimestrais.' },
        { speaker: 'You', text: 'Any questions?', translation: 'Alguma pergunta?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Let me show you the next slide.', pt: 'Deixe-me mostrar o próximo slide.' },
        { en: 'In conclusion, we achieved our goals.', pt: 'Em conclusão, alcançamos nossas metas.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Chart" significa:', options: ['Carta', 'Gráfico', 'Mapa', 'Tabela'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: 'Como começar uma apresentação?', options: ['Start now', 'Good morning, today I will present...', 'Hello start', 'Begin presentation'], correct: 1 },
    ],
  },
  'bs-6': {
    id: 'bs-6',
    title: 'Negotiations',
    titlePt: 'Negociações',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário para negociações.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'negotiate', pt: 'negociar', audio: true },
        { en: 'offer', pt: 'oferta', audio: true },
        { en: 'counteroffer', pt: 'contra-oferta', audio: true },
        { en: 'deal', pt: 'acordo', audio: true },
        { en: 'terms', pt: 'termos', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Client', text: 'We would like to discuss the price.', translation: 'Gostaríamos de discutir o preço.' },
        { speaker: 'You', text: 'We can offer a 10% discount.', translation: 'Podemos oferecer 10% de desconto.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'What are your terms?', pt: 'Quais são seus termos?' },
        { en: 'I think we can reach a deal.', pt: 'Acho que podemos chegar a um acordo.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Deal" significa:', options: ['Lidar', 'Acordo', 'Dar', 'Dividir'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Counteroffer" significa:', options: ['Oferta contrária', 'Contra-oferta', 'Oferta de contador', 'Contar oferta'], correct: 1 },
    ],
  },
  'bs-7': {
    id: 'bs-7',
    title: 'Business Reports',
    titlePt: 'Relatórios Empresariais',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a escrever e entender relatórios empresariais.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'report', pt: 'relatório', audio: true },
        { en: 'summary', pt: 'resumo', audio: true },
        { en: 'findings', pt: 'descobertas', audio: true },
        { en: 'recommendations', pt: 'recomendações', audio: true },
        { en: 'analysis', pt: 'análise', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Manager', text: 'Can you prepare the monthly report?', translation: 'Você pode preparar o relatório mensal?' },
        { speaker: 'You', text: 'Yes. Should I include recommendations?', translation: 'Sim. Devo incluir recomendações?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'The report shows positive results.', pt: 'O relatório mostra resultados positivos.' },
        { en: 'Based on our analysis...', pt: 'Baseado em nossa análise...' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Findings" significa:', options: ['Fundamentos', 'Descobertas', 'Finais', 'Fundos'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Summary" significa:', options: ['Somatório', 'Resumo', 'Sumário', 'Simular'], correct: 1 },
    ],
  },
  'bs-8': {
    id: 'bs-8',
    title: 'Customer Service',
    titlePt: 'Atendimento ao Cliente',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda inglês para atendimento ao cliente.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'customer service', pt: 'atendimento ao cliente', audio: true },
        { en: 'complaint', pt: 'reclamação', audio: true },
        { en: 'refund', pt: 'reembolso', audio: true },
        { en: 'exchange', pt: 'troca', audio: true },
        { en: 'satisfaction', pt: 'satisfação', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Customer', text: 'I would like to make a complaint.', translation: 'Gostaria de fazer uma reclamação.' },
        { speaker: 'You', text: 'I apologize for the inconvenience. How can I help?', translation: 'Peço desculpas pelo inconveniente. Como posso ajudar?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Your satisfaction is our priority.', pt: 'Sua satisfação é nossa prioridade.' },
        { en: 'Would you like an exchange or refund?', pt: 'Você gostaria de uma troca ou reembolso?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Refund" significa:', options: ['Refundir', 'Reembolso', 'Fundo', 'Refugar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Complaint" significa:', options: ['Complemento', 'Reclamação', 'Completo', 'Complexo'], correct: 1 },
    ],
  },
  'bs-9': {
    id: 'bs-9',
    title: 'Job Interviews',
    titlePt: 'Entrevistas de Emprego',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a se sair bem em entrevistas de emprego.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'interview', pt: 'entrevista', audio: true },
        { en: 'resume', pt: 'currículo', audio: true },
        { en: 'experience', pt: 'experiência', audio: true },
        { en: 'skills', pt: 'habilidades', audio: true },
        { en: 'strengths', pt: 'pontos fortes', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Interviewer', text: 'Tell me about yourself.', translation: 'Fale sobre você.' },
        { speaker: 'You', text: 'I have 5 years of experience in manufacturing.', translation: 'Tenho 5 anos de experiência em manufatura.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I am a fast learner.', pt: 'Eu aprendo rápido.' },
        { en: 'I work well under pressure.', pt: 'Trabalho bem sob pressão.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Resume" significa:', options: ['Resumir', 'Currículo', 'Resumo', 'Retomar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Strengths" significa:', options: ['Forças', 'Pontos fortes', 'Forte', 'Fortaleza'], correct: 1 },
    ],
  },
  'bs-10': {
    id: 'bs-10',
    title: 'Office Supplies',
    titlePt: 'Material de Escritório',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário de material de escritório.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'stapler', pt: 'grampeador', audio: true },
        { en: 'paper clip', pt: 'clipe de papel', audio: true },
        { en: 'folder', pt: 'pasta', audio: true },
        { en: 'printer', pt: 'impressora', audio: true },
        { en: 'scanner', pt: 'scanner', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Where can I find the stapler?', translation: 'Onde posso encontrar o grampeador?' },
        { speaker: 'Coworker', text: 'It is in the supply closet.', translation: 'Está no armário de suprimentos.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Can I borrow your pen?', pt: 'Posso pegar sua caneta emprestada?' },
        { en: 'I need to make copies.', pt: 'Preciso fazer cópias.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Stapler" significa:', options: ['Estável', 'Grampeador', 'Estaca', 'Estagiário'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Folder" significa:', options: ['Dobrar', 'Pasta', 'Folder', 'Folha'], correct: 1 },
    ],
  },
  'bs-11': {
    id: 'bs-11',
    title: 'Scheduling',
    titlePt: 'Agendamento',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a agendar reuniões e compromissos.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'schedule', pt: 'agendar', audio: true },
        { en: 'appointment', pt: 'compromisso', audio: true },
        { en: 'available', pt: 'disponível', audio: true },
        { en: 'confirm', pt: 'confirmar', audio: true },
        { en: 'cancel', pt: 'cancelar', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'I would like to schedule a meeting.', translation: 'Gostaria de agendar uma reunião.' },
        { speaker: 'Assistant', text: 'When are you available?', translation: 'Quando você está disponível?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Can we reschedule to Friday?', pt: 'Podemos reagendar para sexta?' },
        { en: 'I need to cancel our meeting.', pt: 'Preciso cancelar nossa reunião.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Available" significa:', options: ['Avaliável', 'Disponível', 'Aprovável', 'Avaliar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Cancel" significa:', options: ['Cancelar', 'Cancelado', 'Canção', 'Canal'], correct: 0 },
    ],
  },
  'bs-12': {
    id: 'bs-12',
    title: 'Financial Terms',
    titlePt: 'Termos Financeiros',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda termos financeiros básicos.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'budget', pt: 'orçamento', audio: true },
        { en: 'profit', pt: 'lucro', audio: true },
        { en: 'loss', pt: 'prejuízo', audio: true },
        { en: 'revenue', pt: 'receita', audio: true },
        { en: 'expenses', pt: 'despesas', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Manager', text: 'We need to review the budget.', translation: 'Precisamos revisar o orçamento.' },
        { speaker: 'You', text: 'Our expenses are higher than expected.', translation: 'Nossas despesas estão mais altas que o esperado.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'The company made a profit this quarter.', pt: 'A empresa teve lucro neste trimestre.' },
        { en: 'We need to increase revenue.', pt: 'Precisamos aumentar a receita.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Budget" significa:', options: ['Bolsa', 'Orçamento', 'Balde', 'Botão'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Profit" significa:', options: ['Profeta', 'Lucro', 'Profissão', 'Proibir'], correct: 1 },
    ],
  },
  'bs-13': {
    id: 'bs-13',
    title: 'Marketing Vocabulary',
    titlePt: 'Vocabulário de Marketing',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda termos de marketing.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'marketing', pt: 'marketing', audio: true },
        { en: 'campaign', pt: 'campanha', audio: true },
        { en: 'target audience', pt: 'público-alvo', audio: true },
        { en: 'brand', pt: 'marca', audio: true },
        { en: 'advertisement', pt: 'anúncio', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Manager', text: 'We are launching a new campaign.', translation: 'Estamos lançando uma nova campanha.' },
        { speaker: 'You', text: 'Who is the target audience?', translation: 'Quem é o público-alvo?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'The brand awareness is increasing.', pt: 'O reconhecimento da marca está aumentando.' },
        { en: 'We need more advertisements.', pt: 'Precisamos de mais anúncios.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Target audience" significa:', options: ['Alvo de audiência', 'Público-alvo', 'Meta de ouvintes', 'Objetivo de plateia'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Campaign" significa:', options: ['Campo', 'Campanha', 'Campeão', 'Campeonato'], correct: 1 },
    ],
  },
  'bs-14': {
    id: 'bs-14',
    title: 'Human Resources',
    titlePt: 'Recursos Humanos',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda termos de recursos humanos.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'human resources', pt: 'recursos humanos', audio: true },
        { en: 'hire', pt: 'contratar', audio: true },
        { en: 'fire', pt: 'demitir', audio: true },
        { en: 'salary', pt: 'salário', audio: true },
        { en: 'benefits', pt: 'benefícios', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'HR', text: 'We are hiring new employees.', translation: 'Estamos contratando novos funcionários.' },
        { speaker: 'You', text: 'What are the benefits?', translation: 'Quais são os benefícios?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I need to talk to HR.', pt: 'Preciso falar com o RH.' },
        { en: 'There is a training next week.', pt: 'Há um treinamento na próxima semana.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Hire" significa:', options: ['Alugar', 'Contratar', 'Elevar', 'Herdar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Benefits" significa:', options: ['Benefícios', 'Lucros', 'Ganhos', 'Vantagens'], correct: 0 },
    ],
  },
  'bs-15': {
    id: 'bs-15',
    title: 'Project Management',
    titlePt: 'Gestão de Projetos',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda termos de gestão de projetos.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'project', pt: 'projeto', audio: true },
        { en: 'milestone', pt: 'marco', audio: true },
        { en: 'deliverable', pt: 'entregável', audio: true },
        { en: 'timeline', pt: 'cronograma', audio: true },
        { en: 'scope', pt: 'escopo', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'PM', text: 'We have reached an important milestone.', translation: 'Alcançamos um marco importante.' },
        { speaker: 'You', text: 'What is the next deliverable?', translation: 'Qual é o próximo entregável?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'The project is on schedule.', pt: 'O projeto está no prazo.' },
        { en: 'We need to update the stakeholders.', pt: 'Precisamos atualizar as partes interessadas.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Milestone" significa:', options: ['Pedra miliar', 'Marco', 'Milha', 'Quilômetro'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Scope" significa:', options: ['Escopo', 'Escopar', 'Escolher', 'Escopeta'], correct: 0 },
    ],
  },
  'bs-16': {
    id: 'bs-16',
    title: 'Contracts',
    titlePt: 'Contratos',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda termos de contratos.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'contract', pt: 'contrato', audio: true },
        { en: 'agreement', pt: 'acordo', audio: true },
        { en: 'clause', pt: 'cláusula', audio: true },
        { en: 'signature', pt: 'assinatura', audio: true },
        { en: 'terms and conditions', pt: 'termos e condições', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Lawyer', text: 'Please read the contract carefully.', translation: 'Por favor, leia o contrato com cuidado.' },
        { speaker: 'You', text: 'What does this clause mean?', translation: 'O que esta cláusula significa?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I need to sign the agreement.', pt: 'Preciso assinar o acordo.' },
        { en: 'Review the terms and conditions.', pt: 'Revise os termos e condições.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Clause" significa:', options: ['Clausura', 'Cláusula', 'Clausular', 'Claustro'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Agreement" significa:', options: ['Agregar', 'Acordo', 'Agressão', 'Agrário'], correct: 1 },
    ],
  },
  'bs-17': {
    id: 'bs-17',
    title: 'Networking',
    titlePt: 'Networking',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a fazer networking profissional.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'networking', pt: 'networking', audio: true },
        { en: 'business card', pt: 'cartão de visita', audio: true },
        { en: 'connection', pt: 'conexão', audio: true },
        { en: 'referral', pt: 'indicação', audio: true },
        { en: 'opportunity', pt: 'oportunidade', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'Nice to meet you. Here is my business card.', translation: 'Prazer em conhecê-lo. Aqui está meu cartão de visita.' },
        { speaker: 'Contact', text: 'Thank you. What do you do?', translation: 'Obrigado. O que você faz?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Can I have your contact information?', pt: 'Posso ter suas informações de contato?' },
        { en: 'I was referred by Mr. Tanaka.', pt: 'Fui indicado pelo Sr. Tanaka.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Business card" significa:', options: ['Cartão de crédito', 'Cartão de visita', 'Cartão de negócios', 'Cartão comercial'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Referral" significa:', options: ['Referência', 'Indicação', 'Referencial', 'Referee'], correct: 1 },
    ],
  },
  'bs-18': {
    id: 'bs-18',
    title: 'Business Travel',
    titlePt: 'Viagens de Negócios',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário para viagens de negócios.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'business trip', pt: 'viagem de negócios', audio: true },
        { en: 'flight', pt: 'voo', audio: true },
        { en: 'hotel reservation', pt: 'reserva de hotel', audio: true },
        { en: 'expense report', pt: 'relatório de despesas', audio: true },
        { en: 'itinerary', pt: 'itinerário', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Manager', text: 'You have a business trip next week.', translation: 'Você tem uma viagem de negócios na próxima semana.' },
        { speaker: 'You', text: 'What is the itinerary?', translation: 'Qual é o itinerário?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I need to book a flight.', pt: 'Preciso reservar um voo.' },
        { en: 'I will submit the expense report.', pt: 'Vou enviar o relatório de despesas.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Business trip" significa:', options: ['Tropeço de negócios', 'Viagem de negócios', 'Negócio de viagem', 'Passo de negócios'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Itinerary" significa:', options: ['Itinerante', 'Itinerário', 'Iteração', 'Interino'], correct: 1 },
    ],
  },
  'bs-19': {
    id: 'bs-19',
    title: 'Leadership Terms',
    titlePt: 'Termos de Liderança',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda vocabulário de liderança.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'leadership', pt: 'liderança', audio: true },
        { en: 'delegate', pt: 'delegar', audio: true },
        { en: 'motivate', pt: 'motivar', audio: true },
        { en: 'mentor', pt: 'mentor', audio: true },
        { en: 'vision', pt: 'visão', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'CEO', text: 'A good leader delegates tasks.', translation: 'Um bom líder delega tarefas.' },
        { speaker: 'You', text: 'How do you motivate your team?', translation: 'Como você motiva sua equipe?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I try to empower my team.', pt: 'Tento empoderar minha equipe.' },
        { en: 'She is a great mentor.', pt: 'Ela é uma ótima mentora.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Delegate" significa:', options: ['Delegado', 'Delegar', 'Delicado', 'Deletar'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Motivate" significa:', options: ['Motivo', 'Motivar', 'Motorizar', 'Modificar'], correct: 1 },
    ],
  },
  'bs-20': {
    id: 'bs-20',
    title: 'Company Structure',
    titlePt: 'Estrutura da Empresa',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda sobre estrutura organizacional.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'CEO', pt: 'diretor executivo', audio: true },
        { en: 'manager', pt: 'gerente', audio: true },
        { en: 'supervisor', pt: 'supervisor', audio: true },
        { en: 'headquarters', pt: 'sede', audio: true },
        { en: 'branch', pt: 'filial', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'New Employee', text: 'How is the company structured?', translation: 'Como a empresa é estruturada?' },
        { speaker: 'You', text: 'We have a CEO and several managers.', translation: 'Temos um diretor executivo e vários gerentes.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I report to the department manager.', pt: 'Eu me reporto ao gerente do departamento.' },
        { en: 'Our branch is in Osaka.', pt: 'Nossa filial é em Osaka.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Headquarters" significa:', options: ['Quartos', 'Sede', 'Cabeças', 'Quartel'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Branch" significa:', options: ['Ramo', 'Filial', 'Galho', 'Todas as anteriores'], correct: 3 },
    ],
  },
  'bs-21': {
    id: 'bs-21',
    title: 'Performance Reviews',
    titlePt: 'Avaliações de Desempenho',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda sobre avaliações de desempenho.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'performance review', pt: 'avaliação de desempenho', audio: true },
        { en: 'goals', pt: 'metas', audio: true },
        { en: 'feedback', pt: 'feedback', audio: true },
        { en: 'improvement', pt: 'melhoria', audio: true },
        { en: 'promotion', pt: 'promoção', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Manager', text: 'Let us discuss your performance this year.', translation: 'Vamos discutir seu desempenho este ano.' },
        { speaker: 'You', text: 'I believe I achieved most of my goals.', translation: 'Acredito que alcancei a maioria das minhas metas.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'I am hoping for a promotion.', pt: 'Espero uma promoção.' },
        { en: 'Can we discuss a raise?', pt: 'Podemos discutir um aumento?' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Performance review" significa:', options: ['Revisão de performance', 'Avaliação de desempenho', 'Análise de performance', 'Exame de trabalho'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Promotion" em trabalho significa:', options: ['Propaganda', 'Promoção de cargo', 'Anúncio', 'Divulgação'], correct: 1 },
    ],
  },
  'bs-22': {
    id: 'bs-22',
    title: 'Innovation & Ideas',
    titlePt: 'Inovação e Ideias',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a apresentar ideias e inovações.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'innovation', pt: 'inovação', audio: true },
        { en: 'idea', pt: 'ideia', audio: true },
        { en: 'brainstorm', pt: 'brainstorm', audio: true },
        { en: 'propose', pt: 'propor', audio: true },
        { en: 'solution', pt: 'solução', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'You', text: 'I have an idea to improve the process.', translation: 'Tenho uma ideia para melhorar o processo.' },
        { speaker: 'Manager', text: 'Please share your proposal.', translation: 'Por favor, compartilhe sua proposta.' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'Let us brainstorm some ideas.', pt: 'Vamos fazer um brainstorm de ideias.' },
        { en: 'I propose a new solution.', pt: 'Eu proponho uma nova solução.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Brainstorm" significa:', options: ['Tempestade cerebral', 'Reunião de ideias', 'Chuva de ideias', 'Todas as anteriores'], correct: 3 },
      { id: 'q2', type: 'multiple-choice', question: '"Propose" significa:', options: ['Propósito', 'Propor', 'Proposta', 'Próprio'], correct: 1 },
    ],
  },
  'bs-23': {
    id: 'bs-23',
    title: 'Risk Management',
    titlePt: 'Gestão de Riscos',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda termos de gestão de riscos.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'risk', pt: 'risco', audio: true },
        { en: 'assessment', pt: 'avaliação', audio: true },
        { en: 'mitigation', pt: 'mitigação', audio: true },
        { en: 'contingency', pt: 'contingência', audio: true },
        { en: 'impact', pt: 'impacto', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'PM', text: 'We need a risk assessment.', translation: 'Precisamos de uma avaliação de riscos.' },
        { speaker: 'You', text: 'What are the main risks?', translation: 'Quais são os principais riscos?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'We need a contingency plan.', pt: 'Precisamos de um plano de contingência.' },
        { en: 'The risk probability is low.', pt: 'A probabilidade do risco é baixa.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Assessment" significa:', options: ['Assessoria', 'Avaliação', 'Assentamento', 'Assembleia'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Mitigation" significa:', options: ['Mitigação', 'Migração', 'Mutação', 'Moderação'], correct: 0 },
    ],
  },
  'bs-24': {
    id: 'bs-24',
    title: 'Client Relations',
    titlePt: 'Relações com Clientes',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda a gerenciar relações com clientes.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'client', pt: 'cliente', audio: true },
        { en: 'relationship', pt: 'relacionamento', audio: true },
        { en: 'satisfaction', pt: 'satisfação', audio: true },
        { en: 'retention', pt: 'retenção', audio: true },
        { en: 'loyalty', pt: 'fidelidade', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'Manager', text: 'Client satisfaction is our priority.', translation: 'A satisfação do cliente é nossa prioridade.' },
        { speaker: 'You', text: 'How do we measure satisfaction?', translation: 'Como medimos a satisfação?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'We value our client relationships.', pt: 'Valorizamos nossos relacionamentos com clientes.' },
        { en: 'Client retention is important.', pt: 'A retenção de clientes é importante.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Retention" significa:', options: ['Retenção', 'Retorno', 'Retirada', 'Retiro'], correct: 0 },
      { id: 'q2', type: 'multiple-choice', question: '"Loyalty" significa:', options: ['Lealdade', 'Fidelidade', 'Realeza', 'Ambas A e B'], correct: 3 },
    ],
  },
  'bs-25': {
    id: 'bs-25',
    title: 'Strategic Planning',
    titlePt: 'Planejamento Estratégico',
    track: 'business',
    duration: 6,
    xp: 60,
    sections: [
      { type: 'intro', title: 'Situação', content: 'Aprenda sobre planejamento estratégico.' },
      { type: 'vocabulary', title: 'Vocabulário Essencial', words: [
        { en: 'strategy', pt: 'estratégia', audio: true },
        { en: 'planning', pt: 'planejamento', audio: true },
        { en: 'objective', pt: 'objetivo', audio: true },
        { en: 'mission', pt: 'missão', audio: true },
        { en: 'implementation', pt: 'implementação', audio: true },
      ]},
      { type: 'dialog', title: 'Diálogo', conversation: [
        { speaker: 'CEO', text: 'Our mission is to be the market leader.', translation: 'Nossa missão é ser líder de mercado.' },
        { speaker: 'You', text: 'What is our strategy?', translation: 'Qual é nossa estratégia?' },
      ]},
      { type: 'practice', title: 'Pratique', instruction: 'Pratique as frases:', phrases: [
        { en: 'The strategic plan is approved.', pt: 'O plano estratégico foi aprovado.' },
        { en: 'Our objective is clear.', pt: 'Nosso objetivo é claro.' },
      ]},
    ],
    quiz: [
      { id: 'q1', type: 'multiple-choice', question: '"Strategy" significa:', options: ['Estratagema', 'Estratégia', 'Estrato', 'Estratosfera'], correct: 1 },
      { id: 'q2', type: 'multiple-choice', question: '"Implementation" significa:', options: ['Implantação', 'Implementação', 'Implicação', 'Importação'], correct: 1 },
    ],
  },
};

// Default lesson content for lessons without specific content
export const getDefaultLessonContent = (lesson) => ({
  id: lesson.id,
  title: lesson.title,
  titlePt: lesson.titlePt,
  track: 'default',
  duration: lesson.duration,
  xp: lesson.xp,
  sections: [
    {
      type: 'intro',
      title: 'Introdução',
      content: `Nesta lição você vai aprender sobre: ${lesson.titlePt}. Esta é uma lição de ${lesson.type === 'vocabulary' ? 'vocabulário' : lesson.type === 'conversation' ? 'conversação' : 'listening'}.`,
    },
    {
      type: 'vocabulary',
      title: 'Vocabulário',
      words: [
        { en: 'example word', pt: 'palavra exemplo', audio: true },
        { en: 'practice', pt: 'prática', audio: true },
        { en: 'learning', pt: 'aprendizado', audio: true },
      ],
    },
    {
      type: 'practice',
      title: 'Pratique',
      instruction: 'Pratique as frases aprendidas:',
      phrases: [
        { en: 'This is a practice sentence.', pt: 'Esta é uma frase de prática.' },
        { en: 'Keep learning every day.', pt: 'Continue aprendendo todos os dias.' },
      ],
    },
  ],
  quiz: [
    { id: 'q1', type: 'multiple-choice', question: 'Esta é uma pergunta de exemplo?', options: ['Sim', 'Não', 'Talvez', 'Não sei'], correct: 0 },
    { id: 'q2', type: 'multiple-choice', question: 'Você está aprendendo inglês?', options: ['Sim, estou!', 'Não', 'Ainda não', 'Desisti'], correct: 0 },
  ],
});

// Function to get lesson content
export const getLessonContent = (lessonId) => {
  return lessonContents[lessonId] || null;
};

// Current lesson - used as default display
export const currentLesson = lessonContents['dl-16'];

export const phraseCategories = [
  {
    id: 'work',
    name: 'Trabalho',
    icon: '💼',
    phrases: [
      { en: 'I need help with this.', pt: 'Preciso de ajuda com isso.', audio: true },
      { en: 'Where should I put this?', pt: 'Onde devo colocar isso?', audio: true },
      { en: 'Is this correct?', pt: 'Isso está correto?', audio: true },
      { en: 'I don\'t understand.', pt: 'Não entendo.', audio: true },
      { en: 'Can you show me again?', pt: 'Pode me mostrar de novo?', audio: true },
      { en: 'I\'m on my break.', pt: 'Estou no meu intervalo.', audio: true },
      { en: 'What time do we finish?', pt: 'Que horas terminamos?', audio: true },
      { en: 'I\'ll be right back.', pt: 'Já volto.', audio: true },
      { en: 'Sorry, I made a mistake.', pt: 'Desculpe, cometi um erro.', audio: true },
      { en: 'Can I take a break?', pt: 'Posso fazer uma pausa?', audio: true },
    ],
  },
  {
    id: 'shopping',
    name: 'Compras',
    icon: '🛒',
    phrases: [
      { en: 'How much is this?', pt: 'Quanto custa isso?', audio: true },
      { en: 'Do you have this in another size?', pt: 'Tem em outro tamanho?', audio: true },
      { en: 'I\'m just looking.', pt: 'Estou só olhando.', audio: true },
      { en: 'Can I pay by card?', pt: 'Posso pagar com cartão?', audio: true },
      { en: 'Where is the checkout?', pt: 'Onde fica o caixa?', audio: true },
      { en: 'Do you have this in stock?', pt: 'Tem isso em estoque?', audio: true },
      { en: 'Can I get a receipt?', pt: 'Posso ter um recibo?', audio: true },
      { en: 'Is there a discount?', pt: 'Tem desconto?', audio: true },
      { en: 'I\'d like to return this.', pt: 'Gostaria de devolver isso.', audio: true },
      { en: 'Where is the fitting room?', pt: 'Onde fica o provador?', audio: true },
    ],
  },
  {
    id: 'hospital',
    name: 'Hospital',
    icon: '🏥',
    phrases: [
      { en: 'I need a doctor.', pt: 'Preciso de um médico.', audio: true },
      { en: 'I have a fever.', pt: 'Estou com febre.', audio: true },
      { en: 'It hurts here.', pt: 'Dói aqui.', audio: true },
      { en: 'I\'m allergic to...', pt: 'Sou alérgico a...', audio: true },
      { en: 'Where is the pharmacy?', pt: 'Onde fica a farmácia?', audio: true },
      { en: 'I have a headache.', pt: 'Estou com dor de cabeça.', audio: true },
      { en: 'I feel dizzy.', pt: 'Estou tonto.', audio: true },
      { en: 'I can\'t sleep.', pt: 'Não consigo dormir.', audio: true },
      { en: 'I need medicine for...', pt: 'Preciso de remédio para...', audio: true },
      { en: 'How often should I take this?', pt: 'Quantas vezes devo tomar isso?', audio: true },
    ],
  },
  {
    id: 'phone',
    name: 'Telefone',
    icon: '📞',
    phrases: [
      { en: 'Hello, this is...', pt: 'Olá, aqui é o/a...', audio: true },
      { en: 'Can I speak to...?', pt: 'Posso falar com...?', audio: true },
      { en: 'Sorry, wrong number.', pt: 'Desculpe, número errado.', audio: true },
      { en: 'I\'ll call back later.', pt: 'Ligo de volta depois.', audio: true },
      { en: 'Can you repeat that?', pt: 'Pode repetir?', audio: true },
      { en: 'Please hold on.', pt: 'Por favor, aguarde.', audio: true },
      { en: 'He/She is not available.', pt: 'Ele/Ela não está disponível.', audio: true },
      { en: 'Can I leave a message?', pt: 'Posso deixar um recado?', audio: true },
      { en: 'What\'s your phone number?', pt: 'Qual é o seu número de telefone?', audio: true },
      { en: 'The line is busy.', pt: 'A linha está ocupada.', audio: true },
    ],
  },
  {
    id: 'emergency',
    name: 'Emergência',
    icon: '🚨',
    phrases: [
      { en: 'Help!', pt: 'Socorro!', audio: true },
      { en: 'Call the police!', pt: 'Chame a polícia!', audio: true },
      { en: 'I need an ambulance.', pt: 'Preciso de uma ambulância.', audio: true },
      { en: 'There\'s been an accident.', pt: 'Houve um acidente.', audio: true },
      { en: 'I\'m lost.', pt: 'Estou perdido/a.', audio: true },
      { en: 'Fire!', pt: 'Fogo!', audio: true },
      { en: 'Someone is hurt.', pt: 'Alguém está ferido.', audio: true },
      { en: 'Please call for help.', pt: 'Por favor, peça ajuda.', audio: true },
      { en: 'Where is the hospital?', pt: 'Onde fica o hospital?', audio: true },
      { en: 'I need help immediately.', pt: 'Preciso de ajuda imediatamente.', audio: true },
    ],
  },
  {
    id: 'transport',
    name: 'Transporte',
    icon: '🚃',
    phrases: [
      { en: 'Which platform?', pt: 'Qual plataforma?', audio: true },
      { en: 'Does this go to...?', pt: 'Isso vai para...?', audio: true },
      { en: 'What time is the next train?', pt: 'Que horas é o próximo trem?', audio: true },
      { en: 'Is this seat taken?', pt: 'Este lugar está ocupado?', audio: true },
      { en: 'Where do I transfer?', pt: 'Onde faço baldeação?', audio: true },
      { en: 'How much is a ticket to...?', pt: 'Quanto custa uma passagem para...?', audio: true },
      { en: 'Is this the right bus?', pt: 'Este é o ônibus certo?', audio: true },
      { en: 'Please stop here.', pt: 'Por favor, pare aqui.', audio: true },
      { en: 'Where is the station?', pt: 'Onde fica a estação?', audio: true },
      { en: 'The train is delayed.', pt: 'O trem está atrasado.', audio: true },
    ],
  },
  {
    id: 'restaurant',
    name: 'Restaurante',
    icon: '🍽️',
    phrases: [
      { en: 'A table for two, please.', pt: 'Uma mesa para dois, por favor.', audio: true },
      { en: 'Can I see the menu?', pt: 'Posso ver o cardápio?', audio: true },
      { en: 'I\'d like to order...', pt: 'Gostaria de pedir...', audio: true },
      { en: 'What do you recommend?', pt: 'O que você recomenda?', audio: true },
      { en: 'The bill, please.', pt: 'A conta, por favor.', audio: true },
      { en: 'Is this spicy?', pt: 'Isso é picante?', audio: true },
      { en: 'I\'m vegetarian.', pt: 'Sou vegetariano/a.', audio: true },
      { en: 'Can I have more water?', pt: 'Posso ter mais água?', audio: true },
      { en: 'This is delicious!', pt: 'Isso está delicioso!', audio: true },
      { en: 'Do you have Wi-Fi?', pt: 'Vocês têm Wi-Fi?', audio: true },
    ],
  },
  {
    id: 'daily',
    name: 'Dia a Dia',
    icon: '☀️',
    phrases: [
      { en: 'What\'s the weather like?', pt: 'Como está o tempo?', audio: true },
      { en: 'Have a nice day!', pt: 'Tenha um bom dia!', audio: true },
      { en: 'See you tomorrow.', pt: 'Até amanhã.', audio: true },
      { en: 'I\'m tired.', pt: 'Estou cansado/a.', audio: true },
      { en: 'What are you doing?', pt: 'O que você está fazendo?', audio: true },
      { en: 'I don\'t know.', pt: 'Não sei.', audio: true },
      { en: 'That\'s great!', pt: 'Que ótimo!', audio: true },
      { en: 'No problem.', pt: 'Sem problema.', audio: true },
      { en: 'Excuse me.', pt: 'Com licença.', audio: true },
      { en: 'I\'m sorry.', pt: 'Desculpe.', audio: true },
    ],
  },
];

export const reviewQueue = [
  { id: 1, en: 'I need help.', pt: 'Preciso de ajuda.', strength: 0.3, lastReview: '2 days ago' },
  { id: 2, en: 'Where is the bathroom?', pt: 'Onde fica o banheiro?', strength: 0.5, lastReview: '1 day ago' },
  { id: 3, en: 'Can you speak slowly?', pt: 'Pode falar devagar?', strength: 0.4, lastReview: '3 days ago' },
  { id: 4, en: 'I don\'t understand.', pt: 'Não entendo.', strength: 0.6, lastReview: '12 hours ago' },
  { id: 5, en: 'What time is it?', pt: 'Que horas são?', strength: 0.2, lastReview: '4 days ago' },
  { id: 6, en: 'How much does this cost?', pt: 'Quanto custa isso?', strength: 0.4, lastReview: '2 days ago' },
  { id: 7, en: 'I\'m from Brazil.', pt: 'Sou do Brasil.', strength: 0.7, lastReview: '6 hours ago' },
  { id: 8, en: 'Nice to meet you.', pt: 'Prazer em conhecê-lo.', strength: 0.8, lastReview: '1 day ago' },
  { id: 9, en: 'Can you help me?', pt: 'Pode me ajudar?', strength: 0.3, lastReview: '3 days ago' },
  { id: 10, en: 'Where is the train station?', pt: 'Onde fica a estação de trem?', strength: 0.5, lastReview: '2 days ago' },
  { id: 11, en: 'I have a headache.', pt: 'Estou com dor de cabeça.', strength: 0.4, lastReview: '1 day ago' },
  { id: 12, en: 'Thank you very much.', pt: 'Muito obrigado.', strength: 0.9, lastReview: '4 hours ago' },
];

export const achievements = [
  { id: 'first-steps', title: 'Primeiros Passos', description: 'Complete sua primeira lição', icon: '👣', progress: 100, earned: true, earnedDate: '2024-01-15', current: 1, total: 1 },
  { id: 'week-warrior', title: 'Guerreiro da Semana', description: 'Mantenha uma sequência de 7 dias', icon: '🔥', progress: 100, earned: true, earnedDate: '2024-01-22', current: 7, total: 7 },
  { id: 'quiz-master', title: 'Mestre dos Quizzes', description: 'Acerte 10 quizzes com 100%', icon: '🧠', progress: 70, earned: false, current: 7, total: 10 },
  { id: 'vocabulary-king', title: 'Rei do Vocabulário', description: 'Aprenda 100 palavras novas', icon: '📚', progress: 45, earned: false, current: 45, total: 100 },
  { id: 'daily-dedication', title: 'Dedicação Diária', description: 'Complete a meta diária 30 vezes', icon: '🎯', progress: 33, earned: false, current: 10, total: 30 },
  { id: 'track-complete', title: 'Trilha Completa', description: 'Complete uma trilha inteira', icon: '🏆', progress: 48, earned: false, current: 12, total: 25 },
  { id: 'phrase-collector', title: 'Colecionador de Frases', description: 'Aprenda 50 frases prontas', icon: '💬', progress: 60, earned: false, current: 30, total: 50 },
  { id: 'month-streak', title: 'Mês de Fogo', description: 'Mantenha uma sequência de 30 dias', icon: '🌟', progress: 23, earned: false, current: 7, total: 30 },
  { id: 'all-tracks', title: 'Explorador', description: 'Inicie todas as 4 trilhas', icon: '🗺️', progress: 75, earned: false, current: 3, total: 4 },
  { id: 'perfect-lesson', title: 'Perfeição', description: 'Complete 5 lições sem erros', icon: '💎', progress: 40, earned: false, current: 2, total: 5 },
];
